var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g8, _path9, _path0, _path1, _path10, _path11, _path12, _g9, _g0, _g1, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "800px",
    viewBox: "0 0 1200 800",
    style: {
      enableBackground: "new 0 0 1200 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.gt0{opacity:0.4;fill:url(#SVGID_1_);}\n\t.gt1{opacity:0.5;fill:url(#SVGID_00000050630088286753918720000017363474985611208627_);}\n\t.gt2{opacity:0.71;}\n\t.gt3{opacity:0.75;fill:#FFFFFF;}\n\t.gt4{opacity:0.43;fill:#FFFFFF;}\n\t.gt5{opacity:0.72;}\n\t.gt6{opacity:0.65;fill:#FFFFFF;}\n\t.gt7{opacity:0.86;fill:#FFFFFF;}\n\t.gt8{opacity:0.45;fill:#FFFFFF;}\n\t.gt9{fill:url(#SVGID_00000173852341065252534870000017227477651032344247_);}\n\t.gt10{opacity:0.3;}\n\t.gt11{fill:url(#SVGID_00000065063198694853325660000009331065321704464261_);}\n\t.gt12{opacity:0.68;}\n\t.gt13{fill:#FFFFFF;}\n\t.gt14{fill:url(#SVGID_00000000214525378646992530000013745960650088243369_);}\n\t.gt15{fill:url(#SVGID_00000062894252691666282630000012792049461344969351_);}\n\t.gt16{fill:url(#SVGID_00000031916014757647463180000013284476216345397183_);}\n\t.gt17{fill:url(#SVGID_00000044868297139997558500000013929611580004223647_);}\n\t.gt18{fill:url(#SVGID_00000119101192383252319180000013459222142412384658_);}\n\t.gt19{fill:url(#SVGID_00000065035856253086080040000013911432916176235940_);}\n\t.gt20{fill:url(#SVGID_00000108304882993557920430000005221825093039404210_);}\n\t.gt21{fill:url(#SVGID_00000165948799913918121580000011233314378391922104_);}\n\t.gt22{fill:url(#SVGID_00000124156297646067954500000006414624052397404033_);}\n\t.gt23{fill:url(#SVGID_00000137109627380733132440000014823381179889828757_);}\n\t.gt24{fill:url(#SVGID_00000130605579608887006290000017174368419075485081_);}\n\t.gt25{fill:url(#SVGID_00000178162418927771037870000017539790327049647745_);}\n\t.gt26{fill:url(#SVGID_00000142894138170060908820000014991358954390968716_);}\n\t.gt27{fill:url(#SVGID_00000132791225733971292630000016769559363886161844_);}\n\t.gt28{fill:url(#SVGID_00000101806949930214745810000003036019989438130329_);}\n\t.gt29{fill:url(#SVGID_00000085253057373421391490000002554657211503369867_);}\n\t.gt30{fill:url(#SVGID_00000121985556833340588310000010601943830316195733_);}\n\t.gt31{fill:url(#SVGID_00000111901251421535854370000011493272575782200720_);}\n\t.gt32{fill:url(#SVGID_00000158737095903671134000000005636756068391509396_);}\n\t.gt33{fill:url(#SVGID_00000044153602132279069310000011294801198238349233_);}\n\t.gt34{fill:url(#SVGID_00000048458789254261848070000009872169664007549836_);}\n\t.gt35{fill:url(#SVGID_00000160168536412085850230000005385175037496874904_);}\n\t.gt36{fill:url(#SVGID_00000086654211507969995160000015432512774250328222_);}\n\t.gt37{fill:url(#SVGID_00000041979232493192711640000013209527248253646475_);}\n\t.gt38{fill:url(#SVGID_00000169554231675965923050000013340515697502047678_);}\n\t.gt39{fill:url(#SVGID_00000148632148320513702080000014126992444564381107_);}\n\t.gt40{fill:url(#SVGID_00000134935476880185487190000010236821981316533393_);}\n\t.gt41{fill:url(#SVGID_00000145744084699499103140000017950445732843841170_);}\n\t.gt42{fill:url(#SVGID_00000035517902136468386950000014748927447087880578_);}\n\t.gt43{fill:url(#SVGID_00000103960436011965458440000011293458947325663672_);}\n\t.gt44{fill:url(#SVGID_00000057147411759006907620000003915272819087135361_);}\n\t.gt45{fill:url(#SVGID_00000003816521141686995220000004410395723747990674_);}\n\t.gt46{fill:url(#SVGID_00000111160739809661358240000015167583284737892526_);}\n\t.gt47{fill:url(#SVGID_00000021080661649732415530000009442639984675517860_);}\n\t.gt48{opacity:0.5;fill:url(#SVGID_00000145028651264030346390000017456231489201538748_);}\n\t.gt49{fill:url(#SVGID_00000170989491371875834700000004377010116265592231_);}\n\t.gt50{fill:url(#SVGID_00000088102777896108889390000004766162902225490578_);}\n\t.gt51{fill:url(#SVGID_00000098205362598318814490000017790190547502326666_);}\n\t.gt52{fill:url(#SVGID_00000078747718000782852930000007620732353923192962_);}\n\t.gt53{fill:url(#SVGID_00000181084829236736779520000003430738018779135648_);}\n\t.gt54{fill:url(#SVGID_00000059285131275461120980000007764225567449704893_);}\n\t.gt55{fill:url(#SVGID_00000052079403131983184740000010435223048135939226_);}\n\t.gt56{opacity:0.5;}\n\t.gt57{opacity:0.6;fill:url(#SVGID_00000004508250161617348110000000476102429488505777_);}\n\t.gt58{opacity:0.6;fill:url(#SVGID_00000173146400725416016850000003545753237730592920_);}\n\t.gt59{fill:url(#SVGID_00000117638181823602211890000011986792766219855783_);}\n\t.gt60{opacity:0.64;fill:#FFFFFF;}\n\t.gt61{opacity:0.5;fill:url(#SVGID_00000103965215294548919690000008549890266412016050_);}\n\t.gt62{fill:url(#SVGID_00000119116067690827356100000012782303016989115551_);}\n\t.gt63{fill:url(#SVGID_00000120518038807813786680000011606316738382365115_);}\n\t.gt64{fill:url(#SVGID_00000178185094700194513190000009745531947309582731_);}\n\t.gt65{fill:url(#SVGID_00000048472853382164504880000000653176213394838918_);}\n\t.gt66{fill:url(#SVGID_00000178186411446216885260000000391542245925428357_);}\n\t.gt67{fill:url(#SVGID_00000126311679407823911100000015119060900162881668_);}\n\t.gt68{fill:url(#SVGID_00000145059576468811273990000003211308877341023660_);}\n\t.gt69{fill:url(#SVGID_00000176728750435609783100000000228686935846146959_);}\n\t.gt70{fill:url(#SVGID_00000136397766327290287370000017315550965730163340_);}\n\t.gt71{fill:url(#SVGID_00000072281153177609708310000004395738410344187065_);}\n\t.gt72{fill:url(#SVGID_00000102525782097853764020000013856288048681968261_);}\n\t.gt73{fill:url(#SVGID_00000147907558508460837150000000912090717623850939_);}\n\t.gt74{fill:url(#SVGID_00000050633112615606064850000005259690341437292676_);}\n\t.gt75{fill:url(#SVGID_00000153686468530915829220000006438818679678639280_);}\n\t.gt76{fill:url(#SVGID_00000126312992560318823150000007115893097918026116_);}\n\t.gt77{fill:url(#SVGID_00000168800398631059925390000017356434512671716523_);}\n\t.gt78{fill:url(#SVGID_00000066512585922654921570000010393068232137024699_);}\n\t.gt79{fill:url(#SVGID_00000125603700927718270300000007906510724456911502_);}\n\t.gt80{opacity:0.64;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.9316,
    y1: 832.8406,
    x2: 1057.3931,
    y2: 117.2078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gt0",
    d: "M1069.5,368.4c-25.8-36-80.5-55.3-82-109.3c-0.9-35.1,15-54.1-10.5-84c-61.6-72.4-156.6-80.8-237.7-50.6 c-81.1,30.2-145.8,90.8-236,87.1c-49.1-2-94.7-25.3-143.3-29.6c-15-1.3-29-0.2-42,3.2c-49,12.5-92.3,59.7-108.6,112 c-13.2,42.4,3.7,84.3-17.1,125.9c-22.1,44.3-65.7,75-76.6,126.2c-13.2,61.4,37.1,114.7,91.2,116.4c34.4,1.1,98.2-4.4,127.4-25.6 c35.6-25.8,70.6-27.5,112-26.5c78.9,1.9,157.9,19.6,235.8,32.3c66.8,10.8,132.6,26.9,200.3,28.9c49.7,1.5,91.9,2.2,118.8-51.8 C1033.4,558.4,1123.6,443.9,1069.5,368.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158006054846994404480000014235201270284508851_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.5848,
    y1: 123.6065,
    x2: 308.8939,
    y2: 666.8089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000158006054846994404480000014235201270284508851_)"
    },
    d: "M1033.6,379.3 c-23.9-32-74.5-49.1-75.8-97c-0.9-31.1,13.9-48-9.7-74.6c-57-64.2-144.9-71.8-219.9-44.9c-75,26.8-134.9,80.6-218.3,77.4 c-45.4-1.8-87.6-22.4-132.6-26.3c-13.8-1.2-26.8-0.2-38.9,2.8c-45.4,11.1-85.4,53-100.5,99.4c-12.2,37.7,3.4,74.8-15.8,111.7 c-20.5,39.3-60.8,66.6-70.9,112c-12.2,54.5,34.4,101.8,84.4,103.3c31.8,0.9,90.8-3.9,117.9-22.8c32.9-22.9,65.3-24.4,103.7-23.6 c73,1.7,146.1,17.4,218.2,28.6c61.8,9.6,122.7,23.8,185.3,25.7c46,1.3,85,1.9,109.9-46C1000.2,548,1083.7,446.4,1033.6,379.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "gt2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt3",
    d: "M1024.8,386.6c3-1,5.2,2.7,3.1,4.9c-20.9,21.6-74.1,79.9-90.3,131.4c-26.4,84-97.8,171.1-164.2,165.8 C773.4,688.7,702.6,491.3,1024.8,386.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt4",
    d: "M992.5,413.2c-0.6,0.4-1.2,1-1.9,1.5l-1.9,1.6l-3.7,3.3l-7.4,6.6c-4.9,4.5-9.8,9-14.6,13.5 c-9.6,9.1-19.1,18.4-28.4,27.9c-18.5,19-36.6,38.5-53.5,58.9c-8.4,10.2-16.8,20.5-24.7,31.2c-7.9,10.6-15.6,21.4-22.8,32.5 c-7.2,11.1-14.2,22.4-20.4,34.1c-6.3,11.7-12,23.6-17.1,35.9l0,0c-0.1,0.3-0.4,0.4-0.7,0.3c-0.2-0.1-0.4-0.4-0.3-0.6 c4.6-12.5,10.2-24.6,16.2-36.5c6.1-11.8,12.9-23.3,20-34.6c14.4-22.4,30.4-43.8,47.5-64.2c8.5-10.2,17.4-20.2,26.4-30 c9-9.8,18.2-19.4,27.7-28.8c9.4-9.4,19-18.6,28.9-27.5c4.9-4.5,9.9-8.9,14.9-13.3c2.5-2.2,5-4.3,7.6-6.5l3.8-3.2l1.9-1.6 c0.7-0.5,1.3-1,2-1.6c0.2-0.2,0.5-0.1,0.7,0.1C992.8,412.6,992.8,412.9,992.5,413.2L992.5,413.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "gt2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt3",
    d: "M1003.7,509.5c2.2-0.3,3.3,2.7,1.5,3.9c-17.9,12.2-64,45.7-82.9,79.9c-30.8,55.5-93.9,106.9-140.1,93.5 C782.2,686.7,760.6,536.9,1003.7,509.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt4",
    d: "M977,523.7c-0.4,0.2-1,0.5-1.5,0.8l-1.6,0.9l-3.1,1.8l-6.2,3.6c-4.1,2.5-8.2,5-12.2,7.5 c-8.1,5.1-16.2,10.3-24.1,15.7C912.5,564.8,896.9,576,882,588c-7.4,6-14.8,12.1-22,18.4c-7.1,6.4-14.1,12.9-20.9,19.7 c-13.5,13.5-26,28-36.8,43.9c-0.2,0.2-0.5,0.3-0.7,0.1c-0.2-0.1-0.3-0.4-0.1-0.7c5-8.2,10.7-16,16.6-23.6 c6-7.5,12.5-14.7,19.1-21.6c13.4-13.8,27.8-26.6,42.9-38.6c7.5-6,15.2-11.7,23-17.4c7.8-5.6,15.7-11.1,23.8-16.3 c8.1-5.2,16.2-10.3,24.5-15.2c4.1-2.4,8.3-4.8,12.5-7.2c2.1-1.2,4.2-2.3,6.3-3.5l3.2-1.7l1.6-0.8c0.6-0.3,1-0.5,1.7-0.8 c0.3-0.1,0.5,0,0.6,0.3c0.1,0.2,0,0.5-0.2,0.6L977,523.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "gt5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt6",
    d: "M758.6,198c-28.2,43.9-181.7,305.8,38.2,494c0,0,145.5-146.4-30.6-493.6C764.7,195.3,760.5,195.1,758.6,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt7",
    d: "M763.7,250.5c-2.7,16.4-5.1,32.9-7.4,49.4c-2.2,16.5-4.3,33-6.1,49.5c-3.7,33.1-6.7,66.2-8.6,99.4 c-1.9,33.2-2.9,66.5-2,99.7c0.4,16.6,1.4,33.2,3,49.7c1.6,16.5,3.9,33,7.5,49.1l0,0c0.2,1.1-0.4,2.1-1.5,2.4 c-1.1,0.2-2.1-0.4-2.4-1.5l0,0c-3.5-16.4-5.7-33-7.3-49.6c-1.5-16.6-2.4-33.3-2.7-50c-0.7-33.4,0.5-66.7,2.6-99.9 c2.1-33.3,5.3-66.4,9.2-99.5c2-16.5,4.1-33.1,6.4-49.5c2.3-16.5,4.8-33,7.7-49.4c0.1-0.5,0.5-0.8,1-0.7 C763.5,249.6,763.8,250,763.7,250.5L763.7,250.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "gt5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt6",
    d: "M242.4,278.7c-8.1,47-44.3,322.1,207.8,402.5c0,0,70.5-175-201.2-404.9C246.6,274.3,242.9,275.6,242.4,278.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt7",
    d: "M265.5,321.1c3.5,14.8,7.4,29.5,11.4,44.2c4,14.7,8.1,29.3,12.5,43.9c8.6,29.2,17.9,58.1,28.1,86.8 c10.2,28.6,21.2,57,33.8,84.7c6.2,13.8,13,27.5,20.2,40.8c7.2,13.3,15,26.3,23.8,38.7l0,0c0.6,0.9,0.4,2.1-0.5,2.8 c-0.9,0.6-2.1,0.4-2.8-0.5l0,0c-8.8-12.6-16.6-25.8-23.8-39.2c-7.2-13.5-13.9-27.2-20-41.2c-12.4-27.9-23.3-56.4-33.3-85.1 c-10-28.8-19.1-57.8-27.6-87.1c-4.2-14.6-8.3-29.3-12.2-44c-3.9-14.7-7.6-29.5-11.1-44.3c-0.1-0.5,0.2-0.9,0.6-1 C264.9,320.3,265.4,320.6,265.5,321.1L265.5,321.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "gt2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt6",
    d: "M452.1,604.9c0,0,17.1-26.9,8.3-71.6c-8.2-41.4-30.7-139.7-23.5-181c0.3-1.8-2.1-2.8-3.1-1.3 c-11.2,16.5-36.1,59.9-34.9,120.3C400.3,549.2,452.1,604.9,452.1,604.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt8",
    d: "M426.9,388.5c-1.7,4.1-2.9,8.3-3.9,12.6c-0.5,2.1-0.9,4.3-1.4,6.4c-0.3,2.2-0.7,4.3-1,6.5 c-0.2,2.2-0.6,4.3-0.7,6.5c-0.2,2.2-0.4,4.3-0.5,6.5l-0.2,6.5c0,2.2,0,4.4,0.1,6.5c0.2,8.7,0.9,17.4,2.2,26l0.5,3.2l0.2,1.6 l0.3,1.6l1.3,6.4c0.4,2.1,0.9,4.3,1.4,6.4l1.4,6.4c2,8.5,4,17.1,6.2,25.6c2.1,8.5,4.4,17,6.6,25.5c1.1,4.3,2.2,8.5,3.3,12.8 c0.5,2.1,1.1,4.3,1.6,6.4c0.5,2.1,1,4.3,1.4,6.5c1.8,8.6,3.4,17.5,2.9,26.4c0,0.3-0.3,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5l0,0 c-0.1-4.4-0.6-8.7-1.3-13c-0.8-4.3-1.8-8.6-2.9-12.8c-2.2-8.5-4.7-16.9-7.1-25.4l-3.6-12.7c-1.2-4.2-2.3-8.5-3.4-12.8 c-2.3-8.5-4.3-17.1-6.3-25.7l-1.4-6.5c-0.5-2.1-1-4.3-1.3-6.5l-1.2-6.5l-0.3-1.6l-0.2-1.6l-0.4-3.3c-0.3-2.2-0.6-4.4-0.8-6.6 l-0.5-6.6c-0.2-2.2-0.2-4.4-0.3-6.6c0-2.2-0.2-4.4-0.1-6.7c0.1-8.9,0.9-17.7,2.6-26.4c0.4-2.2,0.9-4.3,1.4-6.5l0.9-3.2 c0.3-1.1,0.6-2.1,0.9-3.2c1.3-4.2,2.8-8.4,4.9-12.3C426.8,388.4,426.9,388.4,426.9,388.5C426.9,388.4,426.9,388.5,426.9,388.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090277546480411683650000013895461354909150128_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.6104,
    y1: 361.7979,
    x2: 374.2991,
    y2: 205.8034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F68E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090277546480411683650000013895461354909150128_)"
    },
    d: "M616.6,384.7 c-3.8,85.5-81.6,151.6-174,147.5c-92.3-4.1-164.1-76.7-160.4-162.2c3.8-85.5,81.6-151.6,174-147.5 C548.5,226.5,620.3,299.1,616.6,384.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "gt10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114052157755499821240000008510905070975455882_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0445,
    y1: 366.1379,
    x2: 571.6599,
    y2: 366.1379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000114052157755499821240000008510905070975455882_)"
    },
    cx: 440.4,
    cy: 366.1,
    rx: 131.3,
    ry: 124
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "gt12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M492.2,378.1c0,27.3-1.9,54.7-6.7,81.7c-1.2,6.7-2.6,13.4-4.3,20.1c-1.7,6.6-3.6,13.2-6,19.6 c-2.4,6.4-5.2,12.7-9,18.5c-1.9,2.9-4.1,5.6-6.8,7.9c-1.3,1.1-2.8,2.1-4.4,2.8c-1.6,0.7-3.4,1.2-5.2,1.2c-1.8,0.1-3.6-0.3-5.2-1 c-1.6-0.7-3.2-1.6-4.5-2.7c-2.7-2.2-5-4.9-6.9-7.8c-3.9-5.7-6.7-12-9.1-18.4c-2.4-6.4-4.4-13-6.1-19.6 c-1.7-6.6-3.1-13.3-4.4-20.1c-2.5-13.5-4.1-27.1-5.3-40.7c-1.1-13.6-1.7-27.3-1.8-41c0-6.8,0.2-13.7,0.4-20.5 c0.3-6.8,0.6-13.7,1.1-20.5c1-13.6,2.5-27.2,4.8-40.7c1.1-6.7,2.4-13.5,4-20.1c1.6-6.7,3.4-13.3,5.7-19.7 c1.1-3.2,2.4-6.4,3.8-9.5c1.4-3.1,3-6.2,4.9-9c1.9-2.9,4.1-5.6,6.7-7.8c1.3-1.1,2.8-2,4.5-2.7c1.6-0.6,3.4-1,5.1-0.9 c1.8,0,3.5,0.5,5.1,1.2c1.6,0.7,3.1,1.7,4.4,2.7c2.7,2.2,4.9,4.9,6.9,7.7c3.9,5.7,6.9,11.9,9.5,18.2c2.5,6.4,4.6,12.9,6.5,19.5 c1.8,6.6,3.4,13.3,4.7,20C489.9,323.3,492.1,350.7,492.2,378.1z M490.1,378.1c0-13.6-0.5-27.3-1.6-40.8 c-1.1-13.6-2.8-27.1-5.3-40.5c-1.3-6.7-2.7-13.3-4.5-19.9c-1.7-6.6-3.8-13.1-6.2-19.4c-2.5-6.3-5.3-12.5-9.2-18.2 c-1.9-2.8-4.1-5.4-6.7-7.6c-1.3-1.1-2.7-2-4.2-2.7c-1.5-0.7-3.2-1.1-4.8-1.2c-1.7-0.1-3.3,0.3-4.9,0.9c-1.5,0.6-3,1.6-4.3,2.6 c-2.6,2.2-4.7,4.9-6.5,7.7c-1.8,2.9-3.4,5.9-4.7,9c-1.4,3.1-2.6,6.3-3.7,9.5c-2.2,6.4-4,13-5.5,19.7c-1.5,6.6-2.7,13.3-3.8,20.1 c-2.1,13.5-3.4,27-4.3,40.6c-0.9,13.6-1.2,27.2-1.1,40.9c0,13.6,0.4,27.3,1.4,40.8c1,13.6,2.6,27.1,4.9,40.6 c1.2,6.7,2.5,13.4,4.2,20c1.6,6.6,3.6,13.1,5.9,19.5c2.4,6.4,5.1,12.6,8.8,18.2c1.9,2.8,4,5.4,6.6,7.5c1.3,1,2.7,1.9,4.2,2.6 c1.5,0.6,3.1,1,4.8,0.9c1.6,0,3.2-0.5,4.7-1.2c1.5-0.7,2.9-1.6,4.1-2.7c2.5-2.2,4.6-4.9,6.5-7.7c3.7-5.7,6.4-11.9,8.7-18.3 c2.3-6.4,4.2-12.9,5.8-19.5c1.6-6.6,3-13.3,4.1-20c2.3-13.4,3.9-27,4.9-40.6C489.7,405.3,490.1,391.7,490.1,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M561.1,378.1c-0.1,17.6-2.4,35.2-7.1,52.2c-4.8,16.9-12,33.2-21.8,47.9c-4.9,7.3-10.5,14.2-16.7,20.4 c-6.2,6.2-13.1,11.8-20.5,16.5c-7.5,4.7-15.5,8.4-24,11c-8.4,2.5-17.2,3.9-26,3.9c-8.8,0-17.6-1.3-26.1-3.9 c-8.4-2.5-16.5-6.3-24-10.9c-7.5-4.7-14.3-10.3-20.6-16.5c-6.2-6.2-11.8-13.1-16.7-20.4c-9.8-14.6-17.1-30.9-21.9-47.9 c-2.4-8.5-4.1-17.1-5.3-25.9c-1.2-8.7-1.7-17.5-1.8-26.4c0-8.8,0.6-17.6,1.8-26.4c1.2-8.7,2.9-17.4,5.3-25.9 c4.8-16.9,12.1-33.2,21.9-47.9c4.9-7.3,10.5-14.2,16.7-20.4c6.2-6.2,13.1-11.8,20.6-16.5c7.5-4.7,15.5-8.4,24-10.9 c8.4-2.5,17.2-3.9,26-3.9c8.8,0,17.6,1.3,26,3.9c8.4,2.5,16.5,6.3,23.9,10.9c7.5,4.7,14.3,10.3,20.5,16.5 c6.2,6.2,11.8,13.1,16.7,20.4c9.8,14.6,17.1,30.9,21.9,47.8C558.8,342.9,561,360.5,561.1,378.1z M558.8,378.1 c0-17.4-2.2-34.8-6.8-51.6c-4.6-16.8-11.6-33-21.1-47.5c-4.8-7.3-10.2-14.1-16.3-20.4c-6.1-6.2-12.8-11.9-20.2-16.5 c-7.4-4.7-15.3-8.4-23.7-10.9c-8.3-2.5-17-3.9-25.8-3.9c-8.7,0-17.4,1.4-25.7,3.9c-8.3,2.5-16.3,6.3-23.6,11 c-7.3,4.7-14.1,10.3-20.1,16.5c-6.1,6.2-11.5,13.1-16.3,20.4c-9.6,14.6-16.5,30.8-21.1,47.5c-2.3,8.4-3.9,17-5.1,25.6 c-1.1,8.6-1.7,17.3-1.7,26c0,8.7,0.6,17.4,1.7,26c1.1,8.6,2.8,17.2,5.1,25.6c4.6,16.8,11.6,32.9,21.1,47.5 c4.8,7.3,10.2,14.1,16.3,20.3c6.1,6.2,12.8,11.8,20.1,16.5c7.4,4.6,15.3,8.4,23.6,10.9c8.3,2.5,17,3.9,25.7,3.9 c8.7,0,17.4-1.4,25.7-3.9c8.3-2.5,16.3-6.3,23.6-10.9c7.4-4.7,14.1-10.3,20.2-16.5c6.1-6.2,11.5-13.1,16.3-20.3 c9.6-14.6,16.5-30.7,21.2-47.5C556.6,412.9,558.8,395.5,558.8,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M309.5,318l34.9-0.3l34.9-0.2l69.8-0.1l69.8,0.1l34.9,0.2l34.9,0.3c0.1,0,0.1,0,0.1,0.1 c0,0.1,0,0.1-0.1,0.1l-34.9,0.3l-34.9,0.2l-69.8,0.1l-69.8-0.1l-34.9-0.2l-34.9-0.3c-0.1,0-0.2-0.1-0.2-0.2 C309.3,318,309.4,318,309.5,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M349.9,259.6c8.3-0.1,16.5-0.2,24.8-0.3l24.8-0.2c8.3-0.1,16.5-0.1,24.8-0.1l24.8,0l49.5,0.1l24.8,0.2 c8.3,0.1,16.5,0.2,24.8,0.3c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0.1-0.1,0.1c-8.3,0.1-16.5,0.2-24.8,0.3l-24.8,0.2l-49.5,0.1l-24.8,0 c-8.3,0-16.5,0-24.8-0.1l-24.8-0.2c-8.3-0.1-16.5-0.2-24.8-0.3c-0.1,0-0.2-0.1-0.2-0.2C349.8,259.6,349.9,259.6,349.9,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M297.4,376.4l37.9-0.3l37.9-0.2l75.8-0.1l75.8,0.1l37.9,0.2l37.9,0.3c0.1,0,0.1,0,0.1,0.1 c0,0.1,0,0.1-0.1,0.1l-37.9,0.3l-37.9,0.2l-75.8,0.1l-75.8-0.1l-37.9-0.2l-37.9-0.3c-0.1,0-0.2-0.1-0.2-0.2 C297.2,376.5,297.3,376.4,297.4,376.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M309.5,434.8l34.9-0.3l34.9-0.2l69.8-0.1l69.8,0.1l34.9,0.2l34.9,0.3c0.1,0,0.1,0,0.1,0.1 c0,0.1,0,0.1-0.1,0.1l-34.9,0.3l-34.9,0.2l-69.8,0.1l-69.8-0.1l-34.9-0.2l-34.9-0.3c-0.1,0-0.2-0.1-0.2-0.2 C309.3,434.9,309.4,434.8,309.5,434.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M553,493.9H354.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5H553c0.3,0,0.5,0.2,0.5,0.5 C553.6,493.7,553.3,493.9,553,493.9z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "gt2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt6",
    d: "M184,461.1c-1-2.4,1.9-4.5,3.9-2.8c18.9,16,69.9,56.5,113.3,67c70.6,17,146.4,70.9,145.8,125.8 C446.9,651,288.4,720.5,184,461.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt4",
    d: "M207.7,486.1c0.4,0.4,0.9,0.9,1.4,1.4l1.4,1.5l2.9,2.9l5.9,5.7c4,3.8,8,7.5,12,11.2 c8.1,7.4,16.2,14.7,24.6,21.8c16.7,14.2,33.8,27.9,51.5,40.7c8.9,6.3,17.8,12.7,27,18.6c9.2,5.9,18.5,11.6,28.1,17 c19,10.7,38.9,20.1,59.6,27.1c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.3-0.4,0.4-0.6,0.3c-10.6-3.1-20.9-6.9-31-11.2 c-10.1-4.4-19.9-9.3-29.6-14.5c-19.3-10.6-37.8-22.5-55.6-35.5c-8.9-6.4-17.6-13.2-26.2-20c-8.6-6.9-17-13.9-25.2-21.2 c-8.2-7.3-16.4-14.7-24.3-22.3c-3.9-3.8-7.9-7.7-11.7-11.6c-1.9-2-3.9-3.9-5.7-5.9l-2.8-3l-1.4-1.5c-0.5-0.5-0.9-1-1.4-1.6 c-0.2-0.2-0.1-0.5,0.1-0.7C207.2,485.8,207.5,485.9,207.7,486.1L207.7,486.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018940717336286144460000013734748447071960193_",
    gradientUnits: "userSpaceOnUse",
    x1: 990.4426,
    y1: 197.7,
    x2: 676.0063,
    y2: 706.919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018940717336286144460000013734748447071960193_)"
    },
    d: "M694.5,642.3l135-258.6h-27.7 c-5.1,0-7.9-5.9-4.7-9.9L941,198.5c6.2-7.6,18.6-2.8,18,7L948.9,377c-0.6,9.8-9.3,17.1-19.1,16l-19.3-2.2l-133.9,290 c-3.5,7.6-11,12.4-19.4,12.4h-46.4L694.5,642.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139275398229860163740000012428719160147835021_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.2557,
    y1: 554.1473,
    x2: 524.9651,
    y2: 568.9882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139275398229860163740000012428719160147835021_)"
    },
    d: "M582.9,460.9l95.3,211.7 c5.6,12.5,18.1,20.6,31.9,20.6h49.1c6.5,0,12.5-3.5,15.7-9.2l1.7-3.1l0,0c-5.3,0-10.1-3-12.5-7.7l-127-248.8L582.9,460.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109738775992192851000000012786840959087329980_",
    gradientUnits: "userSpaceOnUse",
    x1: 665.8738,
    y1: 542.869,
    x2: 375.5534,
    y2: 548.4343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109738775992192851000000012786840959087329980_)"
    },
    d: "M649.9,449.5L649.9,449.5 c-9.6-7.5-23.5-5.3-30.3,4.8L479.6,664.8c-11.2,16.9-30.1,27-50.4,27h-19.7l-16-46.2c0,0,130.3-199.7,163.8-229.9 c0,0,33.4-30.1,66.4-7.4c8.7,6,15.3,14.6,19.4,24.4L649.9,449.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172399896793289622010000014273761267390525593_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.2299,
    y1: 699.3533,
    x2: 331.4953,
    y2: 553.2726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2814,
    style: {
      stopColor: "#F3C14A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172399896793289622010000014273761267390525593_)"
    },
    d: "M241,521.3c0,0,23.5-29.3,68.9-33.9 c0,0,21.6,7.4,64.6,84.4c43,77.1,71.5,112.2,105,93l-2.8,4.6c-9.1,15.2-25.6,24.5-43.3,24.5H415c-20.4,0-39.5-9.8-51.5-26.4 C330.1,621,261.6,528.5,241,521.3z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M942.7,259.9c-0.1,0-0.1,0-0.2,0c-0.8-0.1-1.4-0.8-1.3-1.7l0.9-8.4c0.1-0.8,0.8-1.4,1.7-1.3 c0.8,0.1,1.4,0.8,1.3,1.7l-0.9,8.4C944.1,259.3,943.5,259.9,942.7,259.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M822.6,365.6c-0.3,0-0.6-0.1-0.9-0.3c-0.7-0.5-0.8-1.4-0.3-2.1l118.8-154.4c1.4-1.9,3.8-2.5,6-1.6 c2.2,0.9,3.4,3,3.2,5.3l-2.1,18.5c-0.1,0.8-0.8,1.4-1.7,1.3c-0.8-0.1-1.4-0.8-1.3-1.7l2.1-18.5c0.1-1.2-0.6-1.9-1.3-2.2 c-0.7-0.3-1.8-0.3-2.5,0.7L823.8,365C823.5,365.4,823.1,365.6,822.6,365.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M553.1,527.4c-0.3,0-0.6-0.1-0.8-0.3c-0.7-0.5-0.9-1.4-0.4-2.1l61.4-91.1c2.2-3.3,5.9-5.1,9.9-4.8 c4,0.3,7.4,2.6,9.1,6.3c0.4,0.7,0,1.6-0.7,2c-0.7,0.4-1.6,0-2-0.7c-1.2-2.6-3.7-4.3-6.6-4.6c-2.9-0.2-5.6,1.1-7.2,3.5l-61.4,91.1 C554.1,527.2,553.6,527.4,553.1,527.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M537.2,551c-0.3,0-0.6-0.1-0.8-0.3c-0.7-0.5-0.9-1.4-0.4-2.1l3.9-5.8c0.5-0.7,1.4-0.9,2.1-0.4 c0.7,0.5,0.9,1.4,0.4,2.1l-3.9,5.8C538.1,550.8,537.6,551,537.2,551z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083086045869595629980000002591944471017609634_",
    gradientUnits: "userSpaceOnUse",
    x1: 13131.7021,
    y1: 404.7639,
    x2: 13069.9043,
    y2: 440.0369,
    gradientTransform: "matrix(1 0 0 1 -12430.0557 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083086045869595629980000002591944471017609634_)"
    },
    d: "M692.3,462.3c-0.1,0-39.3-68.7-44.6-75.1 c-0.9-1.1-2.3-1.6-3.7-1.5l-10.9,1.3l-12.9,27.8l21.4-12.5c-2.1,14.7,25.4,36.4,34.8,44.4c1,0.8,1,2.3,0.2,3.2l-3.8,3.9 c6.2,6.3,13.3,10.3,21.4,12.2L692.3,462.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001628239438444079290000011559544014787679134_",
    gradientUnits: "userSpaceOnUse",
    x1: -5699.4526,
    y1: -3936.623,
    x2: -5704.1968,
    y2: -3863.8823,
    gradientTransform: "matrix(-0.8974 -0.4412 -0.4412 0.8974 -6157.959 1458.1592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001628239438444079290000011559544014787679134_)"
    },
    d: "M675,451.6c0,0-2.4,0.8-3.2,2.9 c-0.4,1,0,2.2,0.9,2.8c4,2.8,17,12,23,13.8c0.5,0.1,1-0.3,0.9-0.8c-0.3-1.4-1.3-4.2-4.5-8.3l0.3,0.6c0.4,0.7-0.4,1.5-1.2,1.1 C687.2,461.5,679,456.5,675,451.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160177744563493597380000002672324612725209785_",
    gradientUnits: "userSpaceOnUse",
    x1: 13125.7236,
    y1: 413.5606,
    x2: 13337.1641,
    y2: 281.1958,
    gradientTransform: "matrix(1 0 0 1 -12430.0557 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160177744563493597380000002672324612725209785_)"
    },
    d: "M677,479.1c-0.1,0-5.9-14.2-6-14.3 c-5.4-32.8-18.5-60.9-22.4-68.3c-0.7-1.2-1.9-2.1-3.3-2.2l-11-0.9L616.1,418l23.5-7.9c-5,13.9,17.5,40.8,25.1,50.5 c0.8,1,0.6,2.4-0.5,3.1l-4.5,3.1c4.8,7.4,11,12.8,18.5,16.2L677,479.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102511432215900611740000016788011089269118365_",
    gradientUnits: "userSpaceOnUse",
    x1: -4489.2529,
    y1: -5588.4443,
    x2: -4493.9966,
    y2: -5515.709,
    gradientTransform: "matrix(-0.7895 -0.6137 -0.6137 0.7895 -6291.1211 2114.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102511432215900611740000016788011089269118365_)"
    },
    d: "M662.3,465.2c0,0-2.5,0.3-3.7,2.2 c-0.6,0.9-0.4,2.1,0.3,3c3.3,3.6,14.2,15.2,19.8,18.2c0.5,0.2,1-0.1,1-0.6c0-1.4-0.4-4.4-2.8-9l0.2,0.6c0.2,0.8-0.7,1.4-1.4,0.8 C672.2,477.3,665.2,470.8,662.3,465.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039835920379261948690000013999485146893350528_",
    gradientUnits: "userSpaceOnUse",
    x1: 5242.1172,
    y1: 360.475,
    x2: 5191.291,
    y2: 416.1747,
    gradientTransform: "matrix(1 0 0 1 -4598.355 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8D55D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#1C2873"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039835920379261948690000013999485146893350528_)"
    },
    d: "M582.9,388.2c0,0-9.9,14.8-10.7,21.5 c-0.8,6.7,2.7,9.1,13.1,9.9c30.9,2.6,46.2-6.7,46.2-6.7c2.1-13.5,3.6-16.9,21.3-24.3c0,0-22.4,1.8-26.9,0 C621.4,387,582.9,388.2,582.9,388.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010311844923355558020000011978671083544426153_",
    gradientUnits: "userSpaceOnUse",
    x1: -9168.3369,
    y1: -564.5323,
    x2: -9153.1406,
    y2: -526.4132,
    gradientTransform: "matrix(-0.9446 -0.3283 -0.3283 0.9446 -8212.668 -2191.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010311844923355558020000011978671083544426153_)"
    },
    d: "M622.5,305.5c0,0-6.9-8.2-14.3,1.9 c-1.3,1.8-6.4,0.3-8.3,4.1c-1,2-3.1,3.1-5.2,2.7c-5.4-1-14.1-1.1-18.5,7.3c-3.3,6.4-0.8,10.2,2.6,12.3c2.4,1.6,3.3,4.8,1.8,7.3 c-1.4,2.4-1.7,5.6,2,9.5c8.1,8.7,24.3-5.5,24.3-5.5l12.8-30.2L622.5,305.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140698359300457038770000014412840367330473887_",
    gradientUnits: "userSpaceOnUse",
    x1: 13061.0918,
    y1: 337.4037,
    x2: 12915.4121,
    y2: 477.9271,
    gradientTransform: "matrix(1 0 0 1 -12430.0557 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140698359300457038770000014412840367330473887_)"
    },
    d: "M609.7,386.3c0,0,11.6-11,17.3-18.3 c3.1-3.9,4-9.1,2.6-13.9c-2.6-8.8-7.2-17.8-7.6-19.2c-0.6-2.2-13.6-2.1-13.6-2.1s-25.5,16.6-35.5,44.6l11.3,3.5 c0,0,6.7-11.2,13.2-18.3c0,0-11.4,15-11.8,21.2L609.7,386.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127005822999665109120000013618323121671447171_",
    gradientUnits: "userSpaceOnUse",
    x1: -7137.0029,
    y1: 384.4322,
    x2: -7075.4438,
    y2: 384.4322,
    gradientTransform: "matrix(-1 0 0 1 -6543.5923 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127005822999665109120000013618323121671447171_)"
    },
    d: "M631.8,390.6l-8.7-9.5l-10,2.7 c0,0-11.7,1.8-18.4,0C588,382,588,382,588,382l-15.1-4.7l-2.4,6.7c-0.6,1.7,0,3.6,1.5,4.6c1.3,0.9,2.8,2,3.8,2.4 c2,0.9,45.9,0.3,45.9,0.3L631.8,390.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029725848742839281970000002957120372284505504_",
    gradientUnits: "userSpaceOnUse",
    x1: -8930.8896,
    y1: -297.3508,
    x2: -8927.8799,
    y2: -319.3659,
    gradientTransform: "matrix(-0.9974 -7.170000e-02 -7.170000e-02 0.9974 -8310.5234 11.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029725848742839281970000002957120372284505504_)"
    },
    d: "M617.3,317.1l-8.7,16.2 c0.6,3.5,9.5,3.6,10.9,1.5c0.1-0.2,0.2-0.5,0.3-0.7l5.2-10.8c0.2-1.1-2.7-4.6-3.6-5.1l-3.5-1.8 C616.5,315.6,622.1,315.6,617.3,317.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002376171310737574170000007210157006618635150_",
    gradientUnits: "userSpaceOnUse",
    x1: -9188.3447,
    y1: -2435.8203,
    x2: -9160.0107,
    y2: -2486.2456,
    gradientTransform: "matrix(-0.5458 -0.8379 -0.8379 0.5458 -6439.6016 -6033.1948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002376171310737574170000007210157006618635150_)"
    },
    d: "M634.9,313.3c0,0,1,5.5-3.3,12.4 c-4.3,7-8.6,6.6-10.8,4.2c-2.2-2.5-4.8-6.6-3.6-13.6C618.4,309.4,633.4,306.3,634.9,313.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059991642192286352800000017236040144100912815_",
    gradientUnits: "userSpaceOnUse",
    x1: -9182.252,
    y1: -2479.7327,
    x2: -9168.085,
    y2: -2444.1953,
    gradientTransform: "matrix(-0.5458 -0.8379 -0.8379 0.5458 -6439.6016 -6033.1948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059991642192286352800000017236040144100912815_)"
    },
    d: "M622.4,317.1c0,0,7-9.2,12.3-1.2 l-0.1,2.8c0,0,7-0.3,6.2-6.7c-0.8-6.4-6.4-10.8-14.3-8.6c-7.9,2.2-12.5,4.7-13.4,10.2c-0.9,5.5,3.6,4.6,3.6,4.6s1.7-3.8,3.8-4 c2.1-0.3,1.3,2.7,1.3,2.7L622.4,317.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075122903657981112500000014512896493637007523_",
    gradientUnits: "userSpaceOnUse",
    x1: -9182.3135,
    y1: -2432.4321,
    x2: -9153.9795,
    y2: -2482.856,
    gradientTransform: "matrix(-0.5458 -0.8379 -0.8379 0.5458 -6439.6016 -6033.1948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075122903657981112500000014512896493637007523_)"
    },
    d: "M620.8,316.9c0,0,3.6-4.7,0.3-5.7 c-3.3-1-3.2,4.6-2.9,6.7L620.8,316.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181767700453434357330000001798547373801582014_",
    gradientUnits: "userSpaceOnUse",
    x1: -7184.6484,
    y1: 147.7527,
    x2: -7216.8521,
    y2: 156.5788,
    gradientTransform: "matrix(-0.9988 -4.940000e-02 -4.940000e-02 0.9988 -6572.4941 -118.7758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181767700453434357330000001798547373801582014_)"
    },
    d: "M603,394.3 C603,394.3,603.1,394.3,603,394.3l40.1,0c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8l-40,0c-1,0-1.8,0.8-1.8,1.8 C601.3,393.5,602.1,394.3,603,394.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096021212194258631710000014627758528757933446_",
    gradientUnits: "userSpaceOnUse",
    x1: 4327.7021,
    y1: 378.5375,
    x2: 4617.3394,
    y2: 354.169,
    gradientTransform: "matrix(-1 0 0 1 5007.5176 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096021212194258631710000014627758528757933446_)"
    },
    d: "M679,358.1h-33.3 c-2.5,0-4.7,1.4-5.7,3.6l-15.4,32.6H666c1.6,0,3-1,3.6-2.4l11.9-30.2C682.2,359.9,680.9,358.1,679,358.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121980490011107209900000003776060403779128993_",
    gradientUnits: "userSpaceOnUse",
    x1: -7197.2256,
    y1: 368.9308,
    x2: -7207.5938,
    y2: 384.5437,
    gradientTransform: "matrix(-1 0 0 1 -6543.5923 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121980490011107209900000003776060403779128993_)"
    },
    d: "M655.6,374.8c-0.7,2.2-0.2,4.4,1.2,4.9 c1.4,0.4,3.1-1,3.8-3.3c0.7-2.2,0.2-4.4-1.2-4.9C658,371.1,656.3,372.5,655.6,374.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047042428943753680300000015228822068299783306_",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.5289,
    y1: 692.0249,
    x2: 1482.7998,
    y2: 692.0249,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047042428943753680300000015228822068299783306_)"
    },
    d: "M341.3,690.7 c-4.8,0.4-13.2,1.1-19.9,1.4c-4,0.2-6.3-0.2-7.6-0.7c0,0.1,0,0.3,0,0.4c0,0.7,0.6,1.3,1.3,1.3c12.5,0.7,22.5,0.2,26,0 c0.7,0,1.2-0.8,0.8-1.5C341.7,691.3,341.5,691,341.3,690.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021106884025357824490000012713896824029614749_",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.5272,
    y1: 686.4841,
    x2: 1482.0015,
    y2: 686.4841,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021106884025357824490000012713896824029614749_)"
    },
    d: "M321.4,692c6.6-0.3,15-1,19.9-1.4 c-4.8-5.8-19.9-9.8-19.9-9.8h-4.3c-2.9,4.2-3.4,8.3-3.3,10.4C315.1,691.8,317.4,692.2,321.4,692z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946350618910312600000017960516886251677351_",
    gradientUnits: "userSpaceOnUse",
    x1: 1457.139,
    y1: 678.7485,
    x2: 1465.1023,
    y2: 678.7485,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085946350618910312600000017960516886251677351_)"
    },
    d: "M316.4,673.9l0.4,7.9 c0,0.9,0.7,1.6,1.5,1.7c0.9,0.1,2,0.1,3.2-0.3c0.7-0.2,1.3-0.9,1.4-1.6l1.4-7.7H316.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011003350838307593100000015862327189908578179_",
    gradientUnits: "userSpaceOnUse",
    x1: 1398.1683,
    y1: 691.4152,
    x2: 1409.0022,
    y2: 691.4152,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011003350838307593100000015862327189908578179_)"
    },
    d: "M261,692c-2.1-0.3-3.1-1.4-3.4-2.6 c0,0,0,0,0,0c-0.3,1.2,0.4,2.5,1.8,3.1c1.7,0.7,3.6,0.9,5.1,0.8c1.6-0.1,3-0.7,3.8-1.8l0,0C266.7,692.4,264.5,692.5,261,692z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177482706910878778320000009613256344720854179_",
    gradientUnits: "userSpaceOnUse",
    x1: 1398.2472,
    y1: 683.0734,
    x2: 1414.1492,
    y2: 683.0734,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177482706910878778320000009613256344720854179_)"
    },
    d: "M270.9,673.9h-3.5 c-5.4-0.1-8.7,11.2-9.8,15.6c0.4,1.2,1.3,2.3,3.4,2.6c3.5,0.5,5.7,0.4,7.3-0.4c2.9-3.8,4.3-9.4,5-12.7 C274.1,675.2,270.9,673.9,270.9,673.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133523206026039280270000011290696251734242448_",
    gradientUnits: "userSpaceOnUse",
    x1: 1406.5128,
    y1: 672.11,
    x2: 1416.0298,
    y2: 672.11,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133523206026039280270000011290696251734242448_)"
    },
    d: "M267.8,666.5l-2,7.8 c-0.2,1,0.2,1.9,1.1,2.4c1.1,0.6,2.6,1.2,4,1c0.7-0.1,1.2-0.5,1.4-1.2l2.9-8.2L267.8,666.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108291255076292891360000001244742416538250893_",
    gradientUnits: "userSpaceOnUse",
    x1: 1384.4678,
    y1: 699.9409,
    x2: 1509.4886,
    y2: 558.4937,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F68E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108291255076292891360000001244742416538250893_)"
    },
    d: "M265.5,668.8c2.4,2.2,10.3,2.4,10.3,2.4 c28.5-68.4,40.2-78.1,40.2-78.1c-4.1,25.8-0.7,83-0.7,83c4.7,2.1,10.8,0,10.8,0c0.4-42.3,6.9-79.1,14.6-108.2 c-19.3-0.4-29.5-7-32.8-9.7C291.7,584.1,265.5,668.8,265.5,668.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145021263607511464320000008576177142961386659_",
    gradientUnits: "userSpaceOnUse",
    x1: 1526.1968,
    y1: 473.4416,
    x2: 1308.0227,
    y2: 663.1977,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145021263607511464320000008576177142961386659_)"
    },
    d: "M312.7,479.6 c-3.6,18.2-2.3,50.7-1.5,65.6c0.2,4.2-2.7,10-5,13.9c-0.4,0.6-0.1,1.4,0.5,1.7c3.9,2,17.3,8.3,32.8,9.1c1,0.1,2-0.7,2.2-1.6 c11.5-42.9,24.8-70.2,24.8-70.2C351.7,474.5,312.7,479.6,312.7,479.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082333235766024937480000018146635900420717730_",
    gradientUnits: "userSpaceOnUse",
    x1: 1438.5839,
    y1: 636.8655,
    x2: 1443.1442,
    y2: 627.745,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082333235766024937480000018146635900420717730_)"
    },
    d: "M317.9,591.5c-0.2,0-0.3,0-0.5-0.1 c-0.4-0.3-0.6-0.8-0.3-1.3c0.2-0.3,3.8-6.2,11.3-9.8c0.5-0.2,1,0,1.2,0.4c0.2,0.5,0,1-0.4,1.2c-7,3.4-10.5,9.1-10.5,9.1 C318.5,591.3,318.2,591.5,317.9,591.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109017426425187863990000009405007901932268447_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.1145,
    y1: 533.3872,
    x2: 1416.2356,
    y2: 563.3878,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109017426425187863990000009405007901932268447_)"
    },
    d: "M289.8,531.8 c1.2,8.5,4.6,17.7,11.6,27.5l2.6-2.1c0,0-3-12.3-1.3-26.3C298.4,530,293.4,530.9,289.8,531.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069395137769777371090000018296324684566278587_",
    gradientUnits: "userSpaceOnUse",
    x1: 1508.0081,
    y1: 453.3328,
    x2: 1290.818,
    y2: 642.233,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069395137769777371090000018296324684566278587_)"
    },
    d: "M316.7,502l-4.1-22.4 c0,0-27.2,20.8-22.9,52.2c3.6-0.9,8.6-1.8,12.9-0.9C303.9,520.8,307.6,509.8,316.7,502z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030475781734698107170000017513953585589982603_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.1501,
    y1: 492.5878,
    x2: 1324.96,
    y2: 681.4882,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030475781734698107170000017513953585589982603_)"
    },
    d: "M366.5,498L356,520.6 c1.7,13.7,9,19.6,16.9,21.8c0.5-6.2,2.1-11.2,3.5-14.7C366.3,517.3,366.5,498,366.5,498z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042718709166278514750000004835505153209132194_",
    gradientUnits: "userSpaceOnUse",
    x1: 1513.6245,
    y1: 536.225,
    x2: 1540.3055,
    y2: 536.225,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042718709166278514750000004835505153209132194_)"
    },
    d: "M376.4,527.7c-1.5,3.5-3,8.5-3.5,14.7 c21.1,8.2,26.7-7.7,26.7-7.7l-3.9-0.7C386.9,535,380.7,532.1,376.4,527.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127010031829162522980000000263622051395155640_",
    gradientUnits: "userSpaceOnUse",
    x1: 1487.6899,
    y1: 464.9236,
    x2: 1487.3984,
    y2: 514.7485,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127010031829162522980000000263622051395155640_)"
    },
    d: "M356.8,470.1l-5.1,18.6 c-0.6,2.1-2.8,3.2-4.8,2.4c-2.2-0.9-4.9-2.1-7.3-3.3c-2.5-1.4-3.3-4.6-1.7-7l10.5-15.7L356.8,470.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035491582815660360870000014014914832958755262_",
    gradientUnits: "userSpaceOnUse",
    x1: 1413.5302,
    y1: 555.77,
    x2: 1553.2471,
    y2: 555.77,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035491582815660360870000014014914832958755262_)"
    },
    d: "M409.2,522.3l-129.9,47.3 c-5.4,2-8.1,8.2-5.7,13.5l0.4,0.9c2.1,4.7,7.6,6.7,12.3,4.6l126.1-58.3L409.2,522.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078025841365680819030000009125763434444032414_",
    gradientUnits: "userSpaceOnUse",
    x1: 1545.5583,
    y1: 493.817,
    x2: 1673.8057,
    y2: 493.817,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000078025841365680819030000009125763434444032414_)"
    },
    cx: 468.9,
    cy: 493.8,
    rx: 64.1,
    ry: 63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172436760132626152940000001993629928594326691_",
    gradientUnits: "userSpaceOnUse",
    x1: 1538.3297,
    y1: 493.817,
    x2: 1681.0344,
    y2: 493.817,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172436760132626152940000001993629928594326691_)"
    },
    d: "M468.9,423.8 c-39.4,0-71.4,31.4-71.4,70.1c0,38.7,31.9,70.1,71.4,70.1c39.4,0,71.4-31.4,71.4-70.1C540.3,455.1,508.4,423.8,468.9,423.8z  M468.9,553.6c-33.6,0-60.9-26.8-60.9-59.8c0-33,27.3-59.8,60.9-59.8c33.6,0,60.9,26.8,60.9,59.8 C529.8,526.8,502.6,553.6,468.9,553.6z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M403,502.5c-0.2,0-0.5-0.2-0.5-0.4c-0.2-1.7-0.4-3.4-0.4-5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5 c0.1,1.6,0.2,3.3,0.4,4.9C403.6,502.2,403.4,502.5,403,502.5C403.1,502.5,403,502.5,403,502.5z M403.5,482.9 C403.5,482.9,403.5,482.9,403.5,482.9c-0.4-0.1-0.5-0.3-0.5-0.6c0.8-4.5,2.1-8.9,3.9-13.2c0,0,0,0,0,0 c10.3-25,34.7-41.1,62.1-41.1c12.8,0,25.2,3.6,35.9,10.3c0.2,0.1,0.3,0.5,0.2,0.7c-0.1,0.2-0.5,0.3-0.7,0.2 c-10.6-6.6-22.8-10.1-35.4-10.1c-27,0-51,15.9-61.2,40.5c-1.7,4.2-3,8.5-3.8,13C404,482.8,403.7,482.9,403.5,482.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150092754841675902330000011881205478677519763_",
    gradientUnits: "userSpaceOnUse",
    x1: 1128.8337,
    y1: 2316.9333,
    x2: 1104.3076,
    y2: 2349.3794,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 -1084.9407 -1675.1407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150092754841675902330000011881205478677519763_)"
    },
    d: "M367.9,455.9c0,0.3-4.2,21.3-4.2,21.3 l-11.9-2.7l1.1-20.5C352.8,454,367.1,450.5,367.9,455.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183241984263590427670000016239563135445389702_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.7635,
    y1: 462.0704,
    x2: 425.8582,
    y2: 472.8295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183241984263590427670000016239563135445389702_)"
    },
    d: "M355.5,458.6l-1.4,10.7 c0,0.1,0,0.3,0,0.4c0.1,0.8,0.7,3.7,3.6,2.9c2.6-0.7,5-1.4,6.7-0.9c0.7,0.2,1.2,1,1,1.7c-0.4,1.9-1.3,6.2-2.7,9.8 c-0.3,0.7-1.1,1.1-1.8,0.9c-2.3-0.7-7-2.2-10.5-4.3c-0.5-0.3-0.8-0.8-0.7-1.4c0.1-2.7,0.4-10.9,0.2-13.2 c-0.3-2.2-2.9-3.5-4.1-3.9c-0.4-0.2-0.7-0.5-0.8-0.8c-0.5-1.3-1.3-4.4,2.6-5.7c0.8-0.3,1.2-1.1,1-2c-0.6-1.6-0.8-4.1,2.2-5.4 c3.1-1.4,5.4,0.3,6.6,1.6c0.5,0.5,1.3,0.6,1.9,0.2c0.4-0.2,0.8-0.3,1.4,0c0.7,0.5,1.7,0.1,2.1-0.6c0.7-1.5,2.2-3.1,5.2-2.6 c5.3,0.9,5.9,6.8,4.5,10.3c-1.4,3.5-7.1,2.1-10,0.4c-2.2-1.3-5,0.1-6.3,0.8C355.8,457.7,355.6,458.1,355.5,458.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104678732465216545240000013612393704096265903_",
    gradientUnits: "userSpaceOnUse",
    x1: 1092.9127,
    y1: 2342.6279,
    x2: 1112.5846,
    y2: 2322.4451,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 -1084.9407 -1675.1407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104678732465216545240000013612393704096265903_)"
    },
    d: "M349.3,469.1c0,0,2.2-6.1-0.1-7.6 c-2.3-1.5-5.6-0.7-4.9,3.7C345.3,470.7,349.3,469.1,349.3,469.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025443259508940200570000008597480670463869074_",
    gradientUnits: "userSpaceOnUse",
    x1: 1463.4934,
    y1: 548.4957,
    x2: 1429.6144,
    y2: 578.4962,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025443259508940200570000008597480670463869074_)"
    },
    d: "M302.9,556.8l12.3-1l5.3,4.9 c0,0-1.3,1.7-5.2,0.7c-3.9-1-9.3-1.2-9.3-1.2s-5.4,2.4-5.5-2.1L302.9,556.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036940060635851246940000007613088921640985773_",
    gradientUnits: "userSpaceOnUse",
    x1: 1537.4709,
    y1: 533.0915,
    x2: 1547.0256,
    y2: 533.0915,
    gradientTransform: "matrix(1 0 0 1 -1140.7335 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036940060635851246940000007613088921640985773_)"
    },
    d: "M398,537.6c1.1,0.8,4.7-0.9,6.9-2.1 c1.1-0.6,1.6-1.9,1.2-3c-0.5-1.7-1.4-3.9-2.5-4.1C401.8,527.9,393.6,534.2,398,537.6z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M281.9,586.6c-0.1,0-0.1,0-0.2,0c-5.1-1.8-6.3-4.8-6.4-7c-0.1-3.2,1.9-6.2,5.1-7.5l15.6-6.1 c0.3-0.1,0.5,0,0.6,0.3c0.1,0.3,0,0.5-0.3,0.6l-15.6,6.1c-2.8,1.1-4.5,3.7-4.4,6.5c0.1,2.8,2,4.8,5.7,6.1c0.3,0.1,0.4,0.4,0.3,0.6 C282.3,586.5,282.1,586.6,281.9,586.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M301,565.2c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3,0-0.5,0.3-0.6l2-0.8c0.3-0.1,0.5,0,0.6,0.3 c0.1,0.3,0,0.5-0.3,0.6l-2,0.8C301.1,565.2,301.1,565.2,301,565.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109720673316900900950000010988402231306151614_",
    gradientUnits: "userSpaceOnUse",
    x1: -689.6776,
    y1: -257.6161,
    x2: -618.5602,
    y2: -257.6161,
    gradientTransform: "matrix(0.7827 0.6224 -0.6224 0.7827 1049.886 850.1642)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52F0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F71FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109720673316900900950000010988402231306151614_)"
    },
    d: "M682.4,204.3c0,0-25,30.2-24.1,33.2 c0.9,3,49.1,42.1,53.1,38.7c4-3.4,26.6-27.8,26.6-27.8C716.4,222.9,685.2,201.7,682.4,204.3z"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M709.8,307.2c-10.3,0-53.6-31.4-70.1-48.1c-8.6-8.8-8.8-11.9-8.2-13.6c3.6-9.9,45.3-73.5,60.9-75.3l0.4,0 l0.3,0.2c8,5.8,77.8,56.7,78.3,65.7c0.4,6.2-20.3,30.6-26.7,37.9c-12.8,14.8-28.9,31.5-33.8,33.2 C710.6,307.2,710.2,307.2,709.8,307.2z M692.2,172.2c-14.1,2.7-55.2,63.7-58.9,74c-0.2,0.6-0.3,3.3,7.8,11.5 c18,18.3,60.4,47.6,68.4,47.6c0.3,0,0.5,0,0.7-0.1c3.8-1.3,18-15.3,33-32.6c15.6-18,26.4-33,26.2-36.5 C769,230.1,723.1,194.7,692.2,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M710.7,277.5c-0.5,0-1-0.1-1.4-0.2c-9.1-2.7-50.7-35.5-51.9-39.4c-0.9-3.1,14.8-22.7,24.3-34.2 c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4c-11.6,14-23.7,29.9-23.9,32.3c2.1,3.9,47.1,39.6,51.5,38.2 c3.8-3.2,25.6-26.6,25.9-26.9c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4c-0.9,1-22.1,23.7-26.1,27.1 C711.6,277.4,711.1,277.5,710.7,277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M731.7,251.2c-11.6,0-34.3-4.7-37.8-6.9c-4.6-2.9-14.5-35.3-12.3-40.4c0.3-0.7,1.1-1.4,3.2-0.8 c5.4,1.7,19.6,12.2,31.3,21.9c8.9,7.4,23.7,20.2,23,23.7c-0.2,0.8-0.7,1.4-1.7,1.8C736.1,251,734.2,251.2,731.7,251.2z  M683.3,204.9c-1.4,4.7,8,35.4,11.6,37.7c3.6,2.3,35.6,8.6,41.6,6c0.4-0.2,0.5-0.3,0.5-0.3c-0.1-2.6-17.7-19-36.4-32.8 C689.3,207,684.4,204.9,683.3,204.9z M682.4,204.3L682.4,204.3L682.4,204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M676,225.2c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.5-1-0.2-1.4l2.4-3c0.3-0.4,1-0.5,1.4-0.2 c0.4,0.3,0.5,1,0.2,1.4l-2.4,3C676.6,225.1,676.3,225.2,676,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M722.4,241.5c-0.3,0-0.6-0.1-0.8-0.4c-5.7-7.2-29.3-23.7-29.5-23.9c-0.5-0.3-0.6-0.9-0.2-1.4 c0.3-0.5,0.9-0.6,1.4-0.2c1,0.7,24,16.9,29.9,24.3c0.3,0.4,0.3,1.1-0.2,1.4C722.8,241.4,722.6,241.5,722.4,241.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "gt56"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151539929764176374590000017865933676435521419_",
    gradientUnits: "userSpaceOnUse",
    x1: 692.6475,
    y1: 338.872,
    x2: 899.2957,
    y2: 381.0236,
    gradientTransform: "matrix(0.9364 1.300000e-02 -1.120000e-02 0.8069 54.3474 -145.598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000151539929764176374590000017865933676435521419_)"
    },
    d: "M719.2,148.6 c-1.9-16.2,16.5-39.1,49.9-18.9c0.9-7.7,42.8-31.5,62.2,18.7c3.3-12.2,33.7-6.1,39.2,14.5c11.4-5.1,38.9,20.4,2.5,24.8 c-46.4,5.6-152.8,4-171.8-23.9C682.1,136,719.2,148.6,719.2,148.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045595625591873878990000003994613476323090326_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.7958,
    y1: 313.0244,
    x2: 1031.3521,
    y2: 340.063,
    gradientTransform: "matrix(0.9364 1.300000e-02 -1.120000e-02 0.8069 54.3474 -145.598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000045595625591873878990000003994613476323090326_)"
    },
    d: "M905.3,126.2 c-1.2-10.4,10.6-25.1,32-12.1c0.6-4.9,27.4-20.2,39.9,12c2.1-7.8,21.6-3.9,25.1,9.3c7.3-3.3,24.9,13.1,1.6,15.9 c-29.8,3.6-98,2.6-110.2-15.3C881.5,118.1,905.3,126.2,905.3,126.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145776087992696555430000001830827652329161859_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.3761,
    y1: 263.3645,
    x2: 600.79,
    y2: 263.3645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145776087992696555430000001830827652329161859_)"
    },
    d: "M284.2,250.4 c44.3-0.7,263.5-4.5,308.5-5.3c4.4-0.1,8.1,3.5,8.1,7.9v20.5c0,4.4-3.6,7.9-7.9,7.9H284.3c-4.4,0-7.9-3.6-7.9-7.9v-15.2 C276.4,254,279.9,250.5,284.2,250.4z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "gt60",
    d: "M340.1,266.2L340.1,266.2c0,4.5,3.7,8.1,8.1,8l178.8-3.1c5.1-0.1,8.8-4.9,7.6-9.9l-0.8-3.3 c-0.9-3.7-4.3-6.2-8-6.1l-178,6.4C343.5,258.4,340.1,261.9,340.1,266.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M300.1,267.4l-27.5,28c-1.2,1.2-1.1,3.1,0.2,4.1l0.2,0.2c1.1,0.9,2.8,0.8,3.7-0.3l25.2-30.4L300.1,267.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121969851466205801570000000630457078879171756_",
    gradientUnits: "userSpaceOnUse",
    x1: 1582.8708,
    y1: 1225.9972,
    x2: 1619.2579,
    y2: 1225.9972,
    gradientTransform: "matrix(0.9025 -0.4307 0.4307 0.9025 -1661.0416 -164.1022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000121969851466205801570000000630457078879171756_)"
    },
    d: "M328.4,244.9 c4.2,8.9,0.3,19.6-8.7,24c-9.1,4.3-19.9,0.6-24.1-8.3c-4.2-8.9-0.3-19.6,8.7-24C313.3,232.3,324.1,236,328.4,244.9z"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M303.4,234.8c-10.1,4.8-14.4,16.8-9.7,26.7c4.7,9.9,16.7,14,26.8,9.2c10.1-4.8,14.4-16.8,9.7-26.7 C325.5,234.2,313.5,230,303.4,234.8z M319.3,268.1c-8.6,4.1-18.9,0.6-22.9-7.9c-4-8.5-0.3-18.6,8.3-22.7 c8.6-4.1,18.9-0.6,22.9,7.9C331.6,253.8,327.9,264,319.3,268.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M293.8,258.4c-0.2,0-0.4-0.1-0.5-0.4c-0.4-1.3-0.6-2.6-0.6-3.9c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.5,0.2,0.5,0.5c0.1,1.3,0.3,2.5,0.6,3.7c0.1,0.3-0.1,0.5-0.3,0.6C293.9,258.4,293.9,258.4,293.8,258.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M277.6,291.9c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l0.4-0.4c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-0.4,0.4C277.9,291.9,277.7,291.9,277.6,291.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029003187690573405980000018403345442013862829_",
    gradientUnits: "userSpaceOnUse",
    x1: 914.699,
    y1: 441.5165,
    x2: 896.2141,
    y2: 498.1765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029003187690573405980000018403345442013862829_)"
    },
    d: "M896.7,445.7c0,0-25.7,32.9,3.6,66.4 l11-1c0,0-21.2-34.1-11.8-61.3l15.6,1.1l8.6-5.6L896.7,445.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033330591651345586570000003849145473596908190_",
    gradientUnits: "userSpaceOnUse",
    x1: 910.7858,
    y1: 642.8602,
    x2: 949.7344,
    y2: 642.8602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033330591651345586570000003849145473596908190_)"
    },
    d: "M910.8,606.9c0,0,20.8,45.4,31.8,64.2 c0,0,2.2,11.8,0,15.6l-1.9,0.8l8.6-0.3c0,0,0.8-15.9,0.2-16.8c-0.6-0.9-1.8-0.8-1.8-0.8s-3.7-29.3-14.4-35.6l-10.4-35.8 L910.8,606.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154424665851878490490000017702393106533129353_",
    gradientUnits: "userSpaceOnUse",
    x1: 964.3217,
    y1: 555.7594,
    x2: 945.0332,
    y2: 681.1343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154424665851878490490000017702393106533129353_)"
    },
    d: "M937,689.7c0,0.2,6.7,0.1,10.4,0 c1.4,0,2.5-1,2.8-2.3l2.8-14.6c0.3-1.4-0.6-2.7-2-3l-1.5-0.4c0,0-2.2,3-1.5,5.9c0.7,2.9,1.3,10.2-0.4,11.1c-1.8,0.9-6.8,1-6.8,1 S937.1,687.9,937,689.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014607192870903010350000009328721191977164184_",
    gradientUnits: "userSpaceOnUse",
    x1: 923.5093,
    y1: 549.4795,
    x2: 904.2205,
    y2: 674.856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014607192870903010350000009328721191977164184_)"
    },
    d: "M891,690c-0.7,0.4-0.4,1.4,0.4,1.4 c6.1-0.1,19.9-0.3,21.1-0.8c1.6-0.7-0.6-6.3-2.8-8.2l-12.5,4.1L891,690z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048485158998592424090000015705554494700389257_",
    gradientUnits: "userSpaceOnUse",
    x1: 887.1519,
    y1: 645.7563,
    x2: 909.7063,
    y2: 645.7563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048485158998592424090000015705554494700389257_)"
    },
    d: "M887.2,604c0,0,13.5,65.1,17.3,77.8 l-9,5.7c0,0,4.5-0.8,7.9-1c3.3-0.2,6.4-4.1,6.4-4.1l-1.1-1.7c0,0-3.4-64.8-2.6-72.1L887.2,604z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108266551710744338430000007320483471889808513_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.5657,
    y1: 476.5387,
    x2: 882.72,
    y2: 476.5387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108266551710744338430000007320483471889808513_)"
    },
    d: "M853.7,452.1c0,0-1.9,33.9,29,51.2 l-7.4,16.9c0,0-27.9-16.9-26.9-63c0-1.3-0.4-2.6-1.3-3.6l-5.9-6.9c-2.3-2.6-3.1-6.2-2.3-9.5l0.8-3.1c0.3-1,1.5-1.5,2.4-1l0.6,0.4 c2,1.1,3.5,2.9,4.5,5l2.9,6.5c1.1,2.4,3.6,3.9,6.3,3.7l1.8-0.2L853.7,452.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140733049213723193380000012882375277155717776_",
    gradientUnits: "userSpaceOnUse",
    x1: 885.5681,
    y1: 501.2851,
    x2: 968.348,
    y2: 665.2375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#102792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3EA7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140733049213723193380000012882375277155717776_)"
    },
    d: "M912.7,508.9c-1.1-1.5-2.9-2.5-4.8-2.8 c-10.2-1.2-22-4.3-26.1-5.4c-0.8-0.2-1.7,0.2-2,1.1l-5.3,16.3c-0.4,1.3,0.1,2.7,1.2,3.4l1.1,0.7c-0.8,2.4-1.8,4.8-0.4,6.9 c4.9,7.1,11,21.4,11,21.4l21.9,0.1l-0.5-6.2l5.3-30.1C914.3,512.4,913.8,510.4,912.7,508.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071556453126166630450000016857991055332509364_",
    gradientUnits: "userSpaceOnUse",
    x1: 867.2386,
    y1: 543.8651,
    x2: 939.5706,
    y2: 625.4394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071556453126166630450000016857991055332509364_)"
    },
    d: "M885.4,547.2l0.4,3.7 c0,0-6.2,18.5,3.1,61.7c0,0,20.1,5.7,36.5-7.9c0,0-4.7-40.8-5.9-42.7c-6.3-9.5-10.5-11.5-10.5-11.5l-0.2-4.1 C908.8,546.5,891.2,549.7,885.4,547.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090284561842731752110000010575213942390806691_",
    gradientUnits: "userSpaceOnUse",
    x1: 893.9894,
    y1: 498.2164,
    x2: 907.7914,
    y2: 498.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090284561842731752110000010575213942390806691_)"
    },
    d: "M894,503.8c-0.1-0.1,4.6-14,4.6-14 l6.6,0.6l2.6,15.8C907.8,506.2,897.4,508.3,894,503.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076597105221270220960000017199317948347987849_",
    gradientUnits: "userSpaceOnUse",
    x1: 4773.0137,
    y1: -2683.3042,
    x2: 4803.4033,
    y2: -2662.6624,
    gradientTransform: "matrix(0.92 0.3919 -0.3919 0.92 -4548.0342 1073.1838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076597105221270220960000017199317948347987849_)"
    },
    d: "M906.9,472.2c0,0-6.8,0-14.3,6.6 c-7.5,6.7-6.2,11.7-2.7,13.8s9,4.4,17.1,1.4C915.1,491.2,915.6,472.5,906.9,472.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098198671374817368890000011225926578024640391_",
    gradientUnits: "userSpaceOnUse",
    x1: 4826.0488,
    y1: -2722.0818,
    x2: 4775.0791,
    y2: -2669.0525,
    gradientTransform: "matrix(0.92 0.3919 -0.3919 0.92 -4548.0342 1073.1838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098198671374817368890000011225926578024640391_)"
    },
    d: "M905,488c0,0,9.5-10.3-1.2-15.1 l-3.3,0.7c0,0-1.1-8.4,6.8-8.9c7.9-0.5,16.3,6.5,15.4,16.5c-1,9.9-5,14.9-11.4,17.1c-6.4,2.2-6.3-3.3-6.3-3.3s4.2-2.9,4-5.4 s-3.6-1-3.6-1L905,488z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120524054910230055400000009818721753251280532_",
    gradientUnits: "userSpaceOnUse",
    x1: 4774.8354,
    y1: -2685.9861,
    x2: 4805.2246,
    y2: -2665.3445,
    gradientTransform: "matrix(0.92 0.3919 -0.3919 0.92 -4548.0342 1073.1838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120524054910230055400000009818721753251280532_)"
    },
    d: "M905.6,489.8c0,0,4.9-5.3,6.7-1.6 c1.9,3.7-4.8,4.8-7.4,5L905.6,489.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028322567159841655120000001304627405833093760_",
    gradientUnits: "userSpaceOnUse",
    x1: 4537.5952,
    y1: -2857.5002,
    x2: 4481.856,
    y2: -2799.5088,
    gradientTransform: "matrix(0.8821 0.471 -0.471 0.8821 -4375.1987 882.0632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028322567159841655120000001304627405833093760_)"
    },
    d: "M919.7,486.4c-0.7-2.3,1.6-4.3,3.9-3.5 c7.2,2.5,16.7,9,13.4,25.4c-3.8,18.6-4.9,28.2-2.5,31.3c1.6,2,0.2,5-2.4,4.9c-1.9-0.1-4.3-1.1-7.1-3.5 C903.4,522.6,923.6,499.7,919.7,486.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062153951814305171610000005243951759540748212_",
    gradientUnits: "userSpaceOnUse",
    x1: -1265.7308,
    y1: 520.9868,
    x2: -1395.4675,
    y2: 785.7398,
    gradientTransform: "matrix(2.0673 -4.080000e-02 -4.080000e-02 1.1532 3565.8076 -319.4515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062153951814305171610000005243951759540748212_)"
    },
    d: "M732.8,365.6l252.7-12.3 c5-0.2,6.3,3.7,6.3,5.8l5.5,82.8c0.1,2.2-4,4.1-9,4.3c-45.7,1.4-245.2,7.9-254.1,8.4c-8.8,0.6-7.7-65.3-7.1-82.2 C727.2,370.5,728,365.9,732.8,365.6z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M735.2,452.4l-0.1-0.3c-3.5-6.7-4.7-34.6-3-71.1c0-0.6,0.8-0.9,1.5-0.9l252.7-12.1c0.3,0,0.7,0,0.9,0.1 c0.6,0.2,0.6,0.5,0.7,0.7l2.2,74c0,0.5-0.6,0.9-1.5,0.9l0,0c-36.3,1.2-219.3,7.3-252.9,8.6L735.2,452.4z M733,381.3 c-1.6,35.7-0.5,63.1,2.8,70.1c34.4-1.3,216.4-7.4,252.6-8.6l0,0c0.2,0,0.4-0.1,0.5-0.1l-2.2-73.6c-0.1,0-0.3-0.1-0.5-0.1 l-252.7,12.1C733.3,381.2,733.1,381.3,733,381.3z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "gt56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M858.3,395.1c-1.1-1-2.5-1.6-4-1.5l-100.5,3.9c-1.5,0.1-2.9,0.7-3.9,1.8c-1,1.1-1.5,2.5-1.4,4l2.3,34.8 c0.2,2.9,2.7,5.2,5.6,5.1l98.3-3.3c2.9-0.1,5.3-2.5,5.3-5.5v-35.4C860,397.6,859.4,396.2,858.3,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M873.6,380.3L747,386.2c-1.4,0.1-2.5,1.6-2.4,3.3l0,0.1c0.1,1.8,1.3,3.2,2.7,3.1l126.6-4.3 c2.2-0.1,4-2,3.9-4.2l0-0.1C877.7,381.9,875.8,380.2,873.6,380.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M975.9,391.3c-0.7-0.7-1.6-1-2.6-1L872,393.6c-1,0-1.9,0.5-2.6,1.2c-0.7,0.8-1,1.7-0.9,2.7l0.2,2 c0.2,1.9,1.8,3.3,3.7,3.2l101.1-4.4c1.9-0.1,3.4-1.7,3.4-3.6v-1C977,392.9,976.6,391.9,975.9,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M975.9,405.1c-0.7-0.7-1.6-1-2.6-1L872,407.4c-1,0-1.9,0.5-2.6,1.2c-0.7,0.8-1,1.7-0.9,2.7l0.2,2 c0.2,1.9,1.8,3.3,3.7,3.2l101.1-4.4c1.9-0.1,3.4-1.7,3.4-3.6v-1C977,406.7,976.6,405.8,975.9,405.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M975.9,418.9c-0.7-0.7-1.6-1-2.6-1L872,421.2c-1,0-1.9,0.5-2.6,1.2c-0.7,0.8-1,1.7-0.9,2.7l0.2,2 c0.2,1.9,1.8,3.3,3.7,3.2l101.1-4.4c1.9-0.1,3.4-1.7,3.4-3.6v-1C977,420.5,976.6,419.6,975.9,418.9z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M952.6,362c0.1,2.7-2,4.9-4.7,5l-3.4,0.1c-2.7,0.1-4.9-2-5-4.7l0-0.1c-0.1-2.7,2-4.9,4.7-5l3.4-0.1 c2.7-0.1,4.9,2,5,4.7L952.6,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M968,361.5c0.1,2.7-2,4.9-4.7,5l-3.4,0.1c-2.7,0.1-4.9-2-5-4.7l0-0.1c-0.1-2.7,2-4.9,4.7-5l3.4-0.1 c2.7-0.1,4.9,2,5,4.7L968,361.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M983.5,361.1c0.1,2.7-2,4.9-4.7,5l-3.4,0.1c-2.7,0.1-4.9-2-5-4.7l0-0.1c-0.1-2.7,2-4.9,4.7-5l3.4-0.1 c2.7-0.1,4.9,2,5,4.7L983.5,361.1z"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M819.4,265.9h-7.1c-0.9,0-1.6-0.7-1.6-1.6v-21.2c0-0.9,0.7-1.6,1.6-1.6h7.1c0.9,0,1.6,0.7,1.6,1.6v21.2 C821,265.2,820.3,265.9,819.4,265.9z M813.9,262.7h3.9v-18h-3.9V262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M833.4,265.9h-9.7c-0.9,0-1.6-0.7-1.6-1.6v-34.9c0-0.9,0.7-1.6,1.6-1.6h9.7c0.9,0,1.6,0.7,1.6,1.6v34.9 C834.9,265.2,834.2,265.9,833.4,265.9z M825.3,262.7h6.5v-31.8h-6.5V262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M851.6,265.9h-13.4c-0.9,0-1.6-0.7-1.6-1.6V222c0-0.9,0.7-1.6,1.6-1.6h13.4c0.9,0,1.6,0.7,1.6,1.6v42.3 C853.2,265.2,852.5,265.9,851.6,265.9z M839.7,262.7H850v-39.2h-10.3V262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M875.9,265.9h-16.1c-0.9,0-1.6-0.7-1.6-1.6v-51.2c0-0.9,0.7-1.6,1.6-1.6h16.1c0.9,0,1.6,0.7,1.6,1.6v51.2 C877.4,265.2,876.7,265.9,875.9,265.9z M861.4,262.7h12.9v-48h-12.9V262.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169531583137306029610000014161836762031618209_",
    gradientUnits: "userSpaceOnUse",
    x1: 12015.4355,
    y1: -3985.5417,
    x2: 11958.3535,
    y2: -4020.137,
    gradientTransform: "matrix(-0.9972 7.430000e-02 0.2459 0.8948 13879.8721 3014.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000169531583137306029610000014161836762031618209_)"
    },
    points: "949.8,310.3 952.8,322.8  960,315.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000198659886174417630000009387914751185894805_",
    gradientUnits: "userSpaceOnUse",
    x1: 11983.7539,
    y1: -3998.3328,
    x2: 11918.4326,
    y2: -4067.4023,
    gradientTransform: "matrix(-0.9972 7.430000e-02 0.2459 0.8948 13879.8721 3014.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000198659886174417630000009387914751185894805_)"
    },
    d: "M1004.5,289.5l-26.7,37.9 c-0.5,0.7-1.3,1.2-2.2,1.3c-0.9,0.1-1.8-0.1-2.5-0.6l-37-28.2c-0.4-0.3-0.6-0.9-0.5-1.4c0.1-0.5,0.6-0.9,1.1-1L1004.5,289.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021821427295251523560000004555502712874885278_",
    gradientUnits: "userSpaceOnUse",
    x1: 12011.2676,
    y1: -3986.1177,
    x2: 11957.9453,
    y2: -4018.4346,
    gradientTransform: "matrix(-0.9972 7.430000e-02 0.2459 0.8948 13879.8721 3014.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000021821427295251523560000004555502712874885278_)"
    },
    points: "949.8,310.3 1004.5,289.5  955.7,314.9 956.4,318.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041276596811223008410000016099862071235022213_",
    gradientUnits: "userSpaceOnUse",
    x1: -15072.0645,
    y1: -3559.0483,
    x2: -15047.6982,
    y2: -3566.1055,
    gradientTransform: "matrix(0.9972 -7.430000e-02 7.430000e-02 0.9972 16238.2773 2751.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041276596811223008410000016099862071235022213_)"
    },
    points: "959.3,317.6 952.8,322.8  955.7,314.9  "
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "gt80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M640.5,349l-2.4-1.7l0,0c-0.3-0.2-0.4-0.7-0.2-1c0.2-0.3,0.7-0.4,1-0.2l0,0l2.5,1.7c0.3,0.2,0.4,0.7,0.2,1 C641.2,349.1,640.8,349.2,640.5,349L640.5,349z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M632.2,343.5l-2.6-1.5l0,0c-0.3-0.2-0.5-0.7-0.2-1c0.2-0.3,0.7-0.5,1-0.2l0,0l2.6,1.6c0.3,0.2,0.5,0.7,0.2,1 C633,343.6,632.5,343.7,632.2,343.5L632.2,343.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M623.5,338.6l-2.7-1.3l0,0c-0.4-0.2-0.5-0.6-0.3-1c0.2-0.4,0.6-0.5,1-0.3l0,0l2.7,1.4c0.4,0.2,0.5,0.6,0.3,1 C624.3,338.6,623.9,338.8,623.5,338.6L623.5,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M614.5,334.4l-2.8-1.1l0,0c-0.4-0.1-0.6-0.6-0.4-1c0.1-0.4,0.6-0.6,1-0.4l0,0l2.8,1.1c0.4,0.2,0.6,0.6,0.4,1 C615.3,334.4,614.9,334.6,614.5,334.4L614.5,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M605.1,331.2l-2.9-0.8l0,0c-0.4-0.1-0.7-0.5-0.5-1c0.1-0.4,0.5-0.7,1-0.5l0,0l2.9,0.8 c0.4,0.1,0.7,0.5,0.5,0.9C606,331.1,605.5,331.4,605.1,331.2L605.1,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M595.5,329l-2.9-0.5l0,0c-0.4-0.1-0.7-0.5-0.7-0.9c0.1-0.4,0.5-0.7,0.9-0.7l0,0l3,0.5 c0.4,0.1,0.7,0.5,0.7,0.9C596.3,328.8,595.9,329.1,595.5,329L595.5,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M585.6,327.8l-3-0.1l0,0c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0l3,0.1c0.4,0,0.8,0.4,0.8,0.8 C586.5,327.5,586.1,327.8,585.6,327.8L585.6,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M575.7,327.8l-3,0.2l0,0c-0.5,0-0.9-0.3-0.9-0.8c0-0.5,0.3-0.9,0.8-0.9l0,0l3-0.2c0.5,0,0.8,0.3,0.9,0.8 C576.5,327.3,576.2,327.7,575.7,327.8L575.7,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M565.9,329l-2.9,0.6l0,0c-0.5,0.1-0.9-0.2-1-0.6c-0.1-0.5,0.2-0.9,0.6-1l0,0l3-0.7c0.5-0.1,0.9,0.2,1,0.6 C566.7,328.5,566.4,328.9,565.9,329L565.9,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M556.4,331.7l-2.8,1.1l0,0c-0.4,0.2-0.9,0-1.1-0.5c-0.2-0.4,0-0.9,0.5-1.1l0,0l2.8-1.1 c0.4-0.2,0.9,0,1.1,0.5C557.1,331,556.9,331.5,556.4,331.7L556.4,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M547.5,335.9c-0.8,0.5-1.7,1-2.5,1.5l0,0c-0.4,0.3-1,0.1-1.2-0.3c-0.3-0.4-0.1-1,0.3-1.2l0,0 c0.9-0.5,1.7-1,2.6-1.6c0.4-0.2,1-0.1,1.2,0.3C548.1,335,547.9,335.6,547.5,335.9L547.5,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M539.4,341.5l-2.2,2l0,0c-0.4,0.3-0.9,0.3-1.3-0.1c-0.3-0.4-0.3-0.9,0.1-1.3l0,0l2.3-2 c0.4-0.3,0.9-0.3,1.3,0.1C539.9,340.5,539.8,341.1,539.4,341.5L539.4,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M532.4,348.4l-1.9,2.3l0,0c-0.3,0.4-0.9,0.5-1.3,0.1c-0.4-0.3-0.5-0.9-0.1-1.3l0,0l1.9-2.4 c0.3-0.4,0.9-0.4,1.3-0.1C532.7,347.4,532.8,348,532.4,348.4L532.4,348.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M526.7,356.4l-1.5,2.6l0,0c-0.3,0.4-0.8,0.6-1.3,0.3c-0.4-0.3-0.6-0.8-0.3-1.3l0,0l1.5-2.6 c0.3-0.4,0.8-0.6,1.3-0.3C526.8,355.3,526.9,355.9,526.7,356.4L526.7,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M522.2,365.1l-1.1,2.7l0,0c-0.2,0.5-0.7,0.7-1.2,0.5c-0.5-0.2-0.7-0.7-0.5-1.2l0,0l1.1-2.8 c0.2-0.5,0.7-0.7,1.2-0.5C522.2,364.1,522.4,364.6,522.2,365.1L522.2,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M519,374.5l-0.7,2.9l0,0c-0.1,0.5-0.7,0.8-1.2,0.7c-0.5-0.1-0.8-0.7-0.7-1.2l0,0l0.7-2.9 c0.1-0.5,0.6-0.8,1.2-0.7C518.8,373.4,519.1,373.9,519,374.5L519,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M517,384.1l-0.3,2.9l0,0c-0.1,0.5-0.5,0.9-1.1,0.9c-0.5-0.1-0.9-0.5-0.9-1.1l0,0l0.3-3 c0.1-0.5,0.5-0.9,1.1-0.9C516.7,383.1,517.1,383.6,517,384.1L517,384.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M516.4,394l0.1,3l0,0c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1v0l-0.1-3c0-0.5,0.4-1,1-1 C515.9,393,516.4,393.4,516.4,394L516.4,394z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M517.1,403.8l0.5,2.9l0,0c0.1,0.6-0.3,1.1-0.8,1.2c-0.6,0.1-1.1-0.3-1.2-0.8l0,0l-0.5-3 c-0.1-0.6,0.3-1.1,0.8-1.1C516.5,402.9,517,403.2,517.1,403.8L517.1,403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M519.1,413.5c0.3,0.9,0.6,1.9,0.9,2.8c0.2,0.5-0.1,1.1-0.7,1.3c-0.5,0.2-1.1-0.1-1.3-0.7l0,0l0,0 c-0.3-1-0.6-1.9-0.9-2.9c-0.2-0.5,0.2-1.1,0.7-1.3C518.3,412.6,518.9,412.9,519.1,413.5L519.1,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M522.4,422.8l1.2,2.7l0,0c0.2,0.5,0,1.1-0.5,1.4c-0.5,0.2-1.1,0-1.4-0.5l0,0l-1.2-2.8 c-0.2-0.5,0-1.1,0.5-1.4C521.5,422,522.1,422.2,522.4,422.8L522.4,422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M526.8,431.6l1.5,2.5l0,0c0.3,0.5,0.1,1.2-0.4,1.5c-0.5,0.3-1.2,0.1-1.5-0.4l0,0l-1.6-2.6 c-0.3-0.5-0.1-1.2,0.4-1.5C525.8,430.9,526.5,431.1,526.8,431.6L526.8,431.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M532.2,439.9l1.8,2.4l0,0c0.4,0.5,0.3,1.2-0.2,1.5s-1.2,0.3-1.5-0.2l0,0l-1.8-2.4c-0.4-0.5-0.3-1.1,0.2-1.5 C531.1,439.3,531.8,439.4,532.2,439.9L532.2,439.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M538.5,447.5l2,2.2l0,0c0.4,0.4,0.4,1.1,0,1.6c-0.4,0.4-1.1,0.4-1.6,0l0,0l-2.1-2.2 c-0.4-0.4-0.4-1.1,0.1-1.5C537.3,447,538,447,538.5,447.5L538.5,447.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M545.5,454.4l2.2,2l0,0c0.5,0.4,0.5,1.1,0.1,1.6c-0.4,0.5-1.1,0.5-1.6,0.1l0,0l-2.3-2 c-0.5-0.4-0.5-1.1-0.1-1.6C544.3,454.1,545,454,545.5,454.4L545.5,454.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M553.1,460.7l2.4,1.7l0,0c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3l0,0l-2.5-1.8 c-0.5-0.4-0.6-1.1-0.2-1.6C551.9,460.4,552.6,460.3,553.1,460.7L553.1,460.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M561.3,466.2l2.6,1.5l0,0c0.5,0.3,0.7,1,0.4,1.6c-0.3,0.5-1,0.7-1.6,0.4l0,0l-2.6-1.6 c-0.5-0.3-0.7-1-0.4-1.6C560.1,466.1,560.8,465.9,561.3,466.2L561.3,466.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M570,471l2.7,1.3l0,0c0.6,0.3,0.8,1,0.5,1.6c-0.3,0.6-1,0.8-1.6,0.5l0,0l-2.7-1.3c-0.6-0.3-0.8-1-0.5-1.6 C568.7,471,569.4,470.8,570,471L570,471z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M579,475.1c0.9,0.4,1.8,0.7,2.8,1.1c0.6,0.2,0.9,0.9,0.7,1.5c-0.2,0.6-0.9,0.9-1.5,0.7l0,0 c-0.9-0.4-1.9-0.7-2.8-1.1c-0.6-0.2-0.9-0.9-0.7-1.5C577.8,475.1,578.4,474.8,579,475.1L579,475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M588.4,478.3l2.9,0.8l0,0c0.6,0.2,1,0.9,0.8,1.5c-0.2,0.6-0.9,1-1.5,0.8l0,0l-2.9-0.9 c-0.6-0.2-1-0.9-0.8-1.5C587.1,478.5,587.7,478.2,588.4,478.3L588.4,478.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M598,480.9l2.9,0.6l0,0c0.7,0.1,1.1,0.8,0.9,1.4c-0.1,0.7-0.8,1.1-1.4,0.9l0,0l-3-0.7 c-0.7-0.1-1.1-0.8-0.9-1.4C596.7,481.2,597.3,480.8,598,480.9L598,480.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M607.7,482.8l2.9,0.4l0,0c0.7,0.1,1.1,0.7,1,1.4c-0.1,0.7-0.7,1.1-1.4,1l0,0l-3-0.5c-0.7-0.1-1.1-0.7-1-1.4 C606.4,483.2,607,482.7,607.7,482.8L607.7,482.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M617.6,484.1l3,0.3l0,0c0.7,0.1,1.2,0.7,1.1,1.4c-0.1,0.7-0.7,1.2-1.4,1.1l0,0l-3-0.3 c-0.7-0.1-1.2-0.7-1.1-1.4C616.2,484.5,616.8,484,617.6,484.1L617.6,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M627.5,484.7l3,0.1l0,0c0.7,0,1.2,0.6,1.2,1.3c0,0.7-0.6,1.2-1.3,1.2h0l-3-0.1c-0.7,0-1.2-0.6-1.2-1.3 C626.2,485.3,626.7,484.7,627.5,484.7L627.5,484.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M637.4,484.9l3,0l0,0c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3h0l-3,0c-0.7,0-1.3-0.6-1.3-1.3 C636.1,485.5,636.7,484.9,637.4,484.9L637.4,484.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M647.3,484.6l3-0.2l0,0c0.7,0,1.3,0.5,1.4,1.2c0,0.7-0.5,1.3-1.2,1.4l0,0l-3,0.2c-0.7,0-1.3-0.5-1.4-1.2 C646,485.2,646.6,484.6,647.3,484.6L647.3,484.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M657.2,483.8l3-0.3l0,0c0.7-0.1,1.4,0.5,1.4,1.2c0.1,0.7-0.5,1.4-1.2,1.4l0,0l-3,0.3 c-0.7,0.1-1.4-0.5-1.4-1.2C656,484.6,656.5,483.9,657.2,483.8L657.2,483.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M667.1,482.7l3-0.4l0,0c0.7-0.1,1.4,0.4,1.5,1.1c0.1,0.7-0.4,1.4-1.1,1.5l0,0l-3,0.4 c-0.7,0.1-1.4-0.4-1.5-1.1C665.9,483.5,666.4,482.8,667.1,482.7L667.1,482.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M677,481.2l2.9-0.5l0,0c0.7-0.1,1.4,0.4,1.6,1.1c0.1,0.7-0.4,1.4-1.1,1.6l0,0l-3,0.5 c-0.7,0.1-1.4-0.4-1.6-1.1C675.7,482,676.2,481.3,677,481.2L677,481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M686.7,479.3l2.9-0.6l0,0c0.7-0.2,1.5,0.3,1.6,1.1c0.2,0.7-0.3,1.5-1.1,1.6l0,0l-2.9,0.6 c-0.7,0.2-1.5-0.3-1.6-1.1C685.5,480.2,686,479.5,686.7,479.3L686.7,479.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M696.5,477.2l2.9-0.7l0,0c0.7-0.2,1.5,0.3,1.7,1s-0.3,1.5-1,1.7l0,0l-2.9,0.7c-0.7,0.2-1.5-0.3-1.7-1 C695.3,478.1,695.7,477.4,696.5,477.2L696.5,477.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M706.1,474.7l2.9-0.8l0,0c0.7-0.2,1.5,0.2,1.7,1c0.2,0.7-0.2,1.5-1,1.7l0,0l-2.9,0.8c-0.7,0.2-1.5-0.2-1.7-1 C704.9,475.7,705.3,474.9,706.1,474.7L706.1,474.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M715.6,471.9l2.8-0.9l0,0c0.7-0.2,1.5,0.2,1.8,0.9c0.2,0.7-0.2,1.5-0.9,1.8l0,0l-2.9,0.9 c-0.7,0.2-1.5-0.2-1.8-0.9C714.5,472.9,714.9,472.1,715.6,471.9L715.6,471.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M725.1,468.8l2.8-1l0,0c0.8-0.3,1.6,0.1,1.8,0.9c0.3,0.7-0.1,1.6-0.9,1.8l0,0l-2.8,1 c-0.7,0.3-1.6-0.1-1.8-0.9C723.9,469.9,724.3,469.1,725.1,468.8L725.1,468.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M734.5,465.5l2.8-1.1l0,0c0.8-0.3,1.6,0.1,1.9,0.8c0.3,0.8-0.1,1.6-0.8,1.9l0,0l-2.8,1.1 c-0.7,0.3-1.6-0.1-1.9-0.8C733.3,466.6,733.7,465.7,734.5,465.5L734.5,465.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M743.8,461.9l2.8-1.1l0,0c0.8-0.3,1.6,0.1,1.9,0.8c0.3,0.8-0.1,1.6-0.8,1.9l0,0l-2.8,1.1 c-0.8,0.3-1.6-0.1-1.9-0.8C742.6,463,743,462.2,743.8,461.9L743.8,461.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M752.9,458l2.7-1.2l0,0c0.8-0.3,1.6,0,2,0.8c0.3,0.8,0,1.6-0.8,2l0,0l-2.8,1.2c-0.8,0.3-1.6,0-1.9-0.8 C751.8,459.2,752.2,458.3,752.9,458L752.9,458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M762,453.9l2.7-1.3l0,0c0.8-0.3,1.6,0,2,0.7c0.3,0.8,0,1.6-0.7,2l-2.7,1.3c-0.8,0.3-1.6,0-2-0.7 C761,455.2,761.3,454.3,762,453.9L762,453.9L762,453.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M771,449.7l2.7-1.3l0,0c0.7-0.4,1.6-0.1,2,0.7c0.4,0.7,0.1,1.6-0.7,2l-2.7,1.3c-0.7,0.4-1.6,0.1-2-0.7 C770,450.9,770.3,450,771,449.7L771,449.7L771,449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M780,445.2l2.7-1.4l0,0c0.7-0.4,1.6-0.1,1.9,0.6c0.4,0.7,0.1,1.6-0.6,1.9l-2.7,1.4c-0.7,0.4-1.6,0.1-2-0.6 C779,446.5,779.2,445.6,780,445.2C779.9,445.2,780,445.2,780,445.2L780,445.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M788.8,440.6l2.6-1.4l0,0c0.7-0.4,1.5-0.1,1.9,0.6c0.4,0.7,0.1,1.5-0.5,1.8l-2.6,1.5 c-0.7,0.4-1.5,0.1-1.9-0.5C787.9,441.9,788.1,441,788.8,440.6C788.8,440.6,788.8,440.6,788.8,440.6L788.8,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M797.6,435.9l2.6-1.5l0,0c0.6-0.4,1.4-0.1,1.8,0.5c0.4,0.6,0.1,1.4-0.5,1.8l-2.6,1.5 c-0.6,0.4-1.4,0.2-1.8-0.5C796.7,437,796.9,436.2,797.6,435.9C797.5,435.9,797.6,435.9,797.6,435.9L797.6,435.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M806.2,430.9l2.6-1.5l0,0c0.6-0.3,1.4-0.1,1.7,0.4c0.3,0.6,0.2,1.3-0.4,1.7l-2.6,1.6 c-0.6,0.4-1.4,0.2-1.7-0.4C805.4,432.1,805.6,431.3,806.2,430.9C806.2,430.9,806.2,430.9,806.2,430.9L806.2,430.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M814.8,425.8l2.6-1.6l0,0c0.6-0.3,1.3-0.2,1.6,0.4c0.3,0.6,0.2,1.3-0.4,1.6l-2.5,1.6 c-0.6,0.4-1.3,0.2-1.7-0.4C814.1,426.9,814.2,426.2,814.8,425.8C814.8,425.8,814.8,425.8,814.8,425.8L814.8,425.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M823.3,420.6l2.5-1.6l0,0c0.5-0.3,1.2-0.2,1.5,0.3c0.3,0.5,0.2,1.2-0.3,1.5l-2.5,1.6 c-0.5,0.3-1.2,0.2-1.6-0.3C822.6,421.6,822.8,420.9,823.3,420.6C823.3,420.6,823.3,420.6,823.3,420.6L823.3,420.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M831.7,415.2l2.5-1.6c0.5-0.3,1.1-0.2,1.5,0.3c0.3,0.5,0.2,1.1-0.3,1.5l-2.5,1.7c-0.5,0.3-1.2,0.2-1.5-0.3 C831.1,416.2,831.2,415.5,831.7,415.2C831.7,415.2,831.7,415.2,831.7,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M840,409.7l2.5-1.7c0.5-0.3,1.1-0.2,1.4,0.3c0.3,0.4,0.2,1.1-0.3,1.4l-2.5,1.7c-0.5,0.3-1.1,0.2-1.4-0.3 C839.4,410.6,839.6,410,840,409.7C840,409.7,840,409.7,840,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M848.3,404l2.5-1.7c0.4-0.3,1-0.2,1.3,0.2c0.3,0.4,0.2,1-0.2,1.3l-2.4,1.7c-0.4,0.3-1,0.2-1.3-0.2 C847.7,404.9,847.8,404.4,848.3,404C848.3,404.1,848.3,404,848.3,404z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M856.5,398.3l2.4-1.7c0.4-0.3,0.9-0.2,1.2,0.2c0.3,0.4,0.2,0.9-0.2,1.2l-2.4,1.8c-0.4,0.3-0.9,0.2-1.2-0.2 C856,399.2,856.1,398.6,856.5,398.3C856.5,398.3,856.5,398.3,856.5,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M864.6,392.5l2.4-1.8c0.4-0.3,0.9-0.2,1.1,0.2c0.3,0.4,0.2,0.9-0.2,1.1l-2.4,1.8c-0.4,0.3-0.9,0.2-1.2-0.2 C864.1,393.3,864.2,392.7,864.6,392.5C864.6,392.5,864.6,392.5,864.6,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M872.6,386.5l2.4-1.8c0.3-0.2,0.8-0.2,1,0.1c0.2,0.3,0.2,0.8-0.1,1l-2.4,1.8c-0.3,0.3-0.8,0.2-1.1-0.1 C872.2,387.3,872.3,386.8,872.6,386.5C872.6,386.5,872.6,386.5,872.6,386.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M880.6,380.5l2.4-1.8c0.3-0.2,0.7-0.2,0.9,0.1c0.2,0.3,0.2,0.7-0.1,0.9l-2.4,1.9c-0.3,0.2-0.7,0.2-1-0.1 C880.2,381.2,880.3,380.7,880.6,380.5C880.6,380.5,880.6,380.5,880.6,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M888.5,374.4l2.4-1.8c0.3-0.2,0.7-0.2,0.9,0.1c0.2,0.3,0.2,0.6-0.1,0.9l-2.3,1.9c-0.3,0.2-0.7,0.2-0.9-0.1 C888.2,375,888.2,374.6,888.5,374.4C888.5,374.4,888.5,374.4,888.5,374.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M896.3,368.2l2.3-1.9c0.2-0.2,0.6-0.2,0.8,0.1c0.2,0.2,0.2,0.6-0.1,0.8l-2.3,1.9c-0.2,0.2-0.6,0.2-0.8-0.1 C896.1,368.8,896.1,368.4,896.3,368.2C896.3,368.2,896.3,368.2,896.3,368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M904.1,362l2.3-1.9c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-2.3,1.9c-0.2,0.2-0.5,0.1-0.7-0.1 C903.9,362.5,903.9,362.1,904.1,362C904.1,362,904.1,362,904.1,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M911.9,355.6l2.3-1.9c0.2-0.1,0.4-0.1,0.6,0.1c0.1,0.2,0.1,0.4-0.1,0.6l-2.3,1.9c-0.2,0.2-0.5,0.1-0.6-0.1 C911.7,356.1,911.7,355.8,911.9,355.6C911.9,355.6,911.9,355.6,911.9,355.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M919.6,349.3l2.3-1.9c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5l-2.3,2c-0.2,0.1-0.4,0.1-0.5,0 C919.4,349.6,919.4,349.4,919.6,349.3C919.6,349.3,919.6,349.3,919.6,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M927.2,342.8l2.3-1.9c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4l-2.3,2c-0.1,0.1-0.3,0.1-0.4,0 C927.1,343.1,927.1,342.9,927.2,342.8C927.2,342.8,927.2,342.8,927.2,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M934.8,336.3l2.3-2c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3l-2.3,2c-0.1,0.1-0.3,0.1-0.4,0 C934.7,336.6,934.7,336.4,934.8,336.3C934.8,336.3,934.8,336.3,934.8,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gt13",
    d: "M942.4,329.8l2.3-2c0.1-0.1,0.2-0.1,0.2,0c0.1,0.1,0.1,0.2,0,0.2l-2.2,2c-0.1,0.1-0.2,0.1-0.3,0 C942.3,330,942.3,329.9,942.4,329.8C942.4,329.8,942.4,329.8,942.4,329.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateBill);
export default __webpack_public_path__ + "static/media/generate_bill.cb913628.svg";
export { ForwardRef as ReactComponent };